<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @del="delall" @save="sava"
                    @exps="exp" @imp="imp" ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-button @click="refreshView" size="mini" type="primary">{{$t('getapi[6411]')}}</el-button>
                <!-- 表格 -->
                <wTable
                        id="xpane-0"
                        :data="datajson"
                        :loading="loading"
                        queryData="ECNViewInfo"
                        :filter_language="['ECN_Status','new_flag','ECN_Urgency']"
                        :filter_date="['create_time']"
                        :header="tableHeader"
                        :option="tableOption"
                        :row-class-name="tableRowClassName"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        :checkflg="false"
                        ref="singleTable"
                        style="margin-top: 2px"
                ></wTable>
                <!-- 表格 -->
            </li>

            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:1120px;min-width: 1120px;overflow:auto">
                    <table>
                        <tr>
                            <td style="width:60px;min-width: 60px"><span>ECN NO</span></td>
                            <td style="width:340px;min-width:340px">
                                <el-select style="width: 80px;" v-model="ecnno" :disabled="ECNMaster.ECN_Status != 0">
                                    <el-option v-for="(item, index) in ecnnolist" :key="index" :value="item.items"
                                               :label="item.items"></el-option>
                                </el-select>
                                -ECN-
                                <el-input v-if="ECNMaster.ECN_Status == 0" style="width: 100px;" v-model="ecnno1"
                                          @click.native.prevent="showsal" class="mcolor" readonly></el-input>
                                <el-input v-if="ECNMaster.ECN_Status != 0" style="width: 100px;" v-model="ecnno1"
                                          readonly></el-input>
                                -
                                <el-input style="width: 100px;" v-model="ecnno2" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:100px;min-width:100px"><span>{{ $t('getapi[112]') }}</span></td>
                            <td style="width:130px;min-width:130px">
                                <el-input
                                        v-model="ECNMaster.Part_Code"
                                        :placeholder="$t('getapi[112]')"
                                        size="mini"
                                        @click.native.prevent="showitem"
                                        class="mcolor"
                                        readonly
                                        v-if="ECNMaster.ECN_Status == 0"
                                ></el-input>
                                <el-input v-if="ECNMaster.ECN_Status != 0" style="width: 130px;" v-model="ECNMaster.Part_Code"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[149]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input
                                        v-model="ECNMaster.Part_Version"
                                        :placeholder="$t('getapi[149]')"
                                        style="width: 115px;"
                                        size="mini"
                                        @click.native.prevent="showitem"
                                        class="mcolor"
                                        readonly
                                ></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{$t('getapi[6700]')}}</span></td>
                            <td >
                                <el-input
                                        v-model="ECNMaster.itemvernum"
                                        :placeholder="$t('getapi[6700]')"
                                        style="width: 115px;"
                                        size="mini"
                                ></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{$t('getapi[6134]')}}</span></td>
                            <td colspan="1" style="white-space: nowrap">
                                <el-input v-model="ECNMaster.Client_Name" :readonly="true" class="readO" size="mini"></el-input>
                            </td>
                            <td  style="width:100px;min-width:100px"><span>{{$t('getapi[6135]')}}</span></td>
                            <td  style="width:100px;min-width:100px"> <el-input v-model="ECNMaster.Product_Name" size="mini"></el-input></td>
                            <td  style="width:100px;min-width:100px"><span>{{$t('getapi[6148]')}}</span></td>
                            <td  style="width:100px;min-width:100px"><el-input v-model="ECNMaster.Client_ECN_No" size="mini"></el-input></td>
                            <td style="width:60px;min-width:60px"><span>{{$t('getapi[6149]')}}</span></td>
                            <td style="width:120px;min-width:120px"><el-input v-model="ECNMaster.Client_Confirm" size="mini"></el-input></td>
                        </tr>
                        <tr>
                            <span>{{$t('getapi[6133]')}}</span>
                            <td style="width:300px;min-width:300px">                                
                                <el-select style="width: 100px;" v-model="ECNMaster.ECN_Source">
                                    <el-option value="0" :label="$t('getapi[8716]')"></el-option>
                                    <el-option value="1" :label="$t('getapi[8717]')"></el-option>
                                </el-select>                             
                                <span>{{$t('getapi[6126]')}}</span>
                                <el-select style="width: 185px;" v-model="ECNMaster.ECN_Type_Code">
                                    <el-option v-for="(item, index) in ecntypelist" :key="index" :value="item.ECN_Type_Code"
                                               :label="item.ECN_Type_Name"></el-option>
                                </el-select>
                            </td>
                            <td><span>{{$t('getapi[6150]')}}</span></td>
                            <td style="width:150px;min-width:150px">
                                <el-select style="width: 150px;" v-model="ECNMaster.Product_Stage_Code">
                                    <el-option v-for="(item, index) in ecnstagelist" :key="index"
                                               :value="item.Product_Stage_Code" :label="item.Product_Stage_Name"></el-option>
                                </el-select>
                            </td>
                            
                            <td><span>{{$t('getapi[6138]')}}</span></td>
                            <td style="width:100px;min-width:100px">                                
                                <el-select v-model="ECNMaster.ECN_Urgency">
                                    <el-option v-for="(item, index) in ugenry" :key="index" :value="item.id"
                                               :label="item.name"></el-option>
                                </el-select>
                            </td>
                            <td><span>{{$t('getapi[552]')}}</span></td>
                            <td style="width:100px;min-width:100px">                                
                                <el-input v-if="ECNMaster.ECN_Status == 0" :value="$t('getapi[1422]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="ECNMaster.ECN_Status == 1" :value="$t('getapi[8718]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="ECNMaster.ECN_Status == 2" :value="$t('getapi[5141]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="ECNMaster.ECN_Status == 3" :value="$t('getapi[2408]')"
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="ECNMaster.ECN_Status == 4" :value="$t('getapi[8719]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="ECNMaster.ECN_Status == 5" :value="$t('getapi[5142]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="ECNMaster.ECN_Status == 6" :value="$t('getapi[5143]')"
                                          :readonly="true" class="readO" size="mini"></el-input>
                                <el-input v-if="ECNMaster.ECN_Status == 7" :value="$t('getapi[441]')" 
                                          :readonly="true" class="readO" size="mini"></el-input>
                            </td>
                            
                        </tr>
                        <tr>
                            <td colspan="2" style="white-space: nowrap">
                                <span>{{$t('getapi[6151]')}}</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="ECNMaster.Annex_Drawing_Num" style="width: 60px;"
                                          size="mini"></el-input>
                                {{$t('getapi[6152]')}}
                                <span>WI</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="ECNMaster.Annex_WI_Num" style="width: 60px;"
                                          size="mini"></el-input>
                                {{$t('getapi[6152]')}}
                                <span>{{$t('getapi[224]')}}</span>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="ECNMaster.Annex_Other_Num" style="width: 60px;"
                                          size="mini"></el-input>
                                {{$t('getapi[6152]')}}
                                <el-button type="danger" size="mini" style="margin-left: 15px;" @click="closeqz"
                                           :disabled="!btn.colse">{{$t('getapi[2345]')}}
                                </el-button>
                            </td>
                            <td colspan="2">
                                <el-checkbox v-model="ECNMaster.New_flag" :true-label="'1'" :false-label="'0'">
                                    {{$t('getapi[6147]')}}
                                </el-checkbox>
                            </td>
                            <td><span>{{$t('getapi[6153]')}}</span></td>
                            <td>
                                <el-input v-model="ECNMaster.ECN_Accept_Person"
                                          @click.native.prevent="showgetpe(0)" readonly></el-input>
                            </td>
                            <td><span>{{$t('getapi[6154]')}}</span></td>
                            <td>
                                <el-date-picker
                                        v-model="ECNMaster.ECN_Accept_Time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        size="mini"
                                        style="width:100%"
                                ></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
                <!--<div class="box" style="height: 125px;">
                    &lt;!&ndash; 编辑弹框 &ndash;&gt;

                    <div class="bbl">
                        <span>ECN NO</span>
                        <el-select style="width: 80px;" v-model="ecnno" :disabled="ECNMaster.ECN_Status != 0">
                            <el-option v-for="(item, index) in ecnnolist" :key="index" :value="item.items"
                                       :label="item.items"></el-option>
                        </el-select>
                        -ECN-
                        <el-input v-if="ECNMaster.ECN_Status == 0" style="width: 100px;" v-model="ecnno1"
                                  @click.native.prevent="showsal" class="mcolor" readonly></el-input>
                        <el-input v-if="ECNMaster.ECN_Status != 0" style="width: 100px;" v-model="ecnno1"
                                  readonly></el-input>
                        -
                        <el-input style="width: 100px;" v-model="ecnno2" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[112]') }}</span>
                        <el-input
                                v-model="ECNMaster.Part_Code"
                                :placeholder="$t('getapi[112]')"
                                style="width: 130px;"
                                size="mini"
                                @click.native.prevent="showitem"
                                class="mcolor"
                                readonly
                                v-if="ECNMaster.ECN_Status == 0"
                        ></el-input>
                        <el-input v-if="ECNMaster.ECN_Status != 0" style="width: 130px;" v-model="ECNMaster.Part_Code"
                                  :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[149]') }}</span>
                        <el-input
                                v-model="ECNMaster.Part_Version"
                                :placeholder="$t('getapi[149]')"
                                style="width: 115px;"
                                size="mini"
                                @click.native.prevent="showitem"
                                class="mcolor"
                                readonly
                        ></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{$t('getapi[6134]')}}</span>
                        <el-input v-model="ECNMaster.Client_Name" :readonly="true" class="readO" style="width: 276px;" size="mini"></el-input>
                        <span>{{$t('getapi[6135]')}}</span>
                        <el-input v-model="ECNMaster.Product_Name" style="width: 130px;" size="mini"></el-input>
                        <span>{{$t('getapi[6148]')}}</span>
                        <el-input v-model="ECNMaster.Client_ECN_No" style="width: 130px;" size="mini"></el-input>
                        <span>{{$t('getapi[6149]')}}</span>
                        <el-input v-model="ECNMaster.Client_Confirm" style="width: 130px;" size="mini"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{$t('getapi[6133]')}}</span>
                        <el-select style="width: 80px;" v-model="ECNMaster.ECN_Source">
                            <el-option value="0" :label="$t('getapi[8716]')"></el-option>
                            <el-option value="1" :label="$t('getapi[8717]')"></el-option>
                        </el-select>
                        <span>{{$t('getapi[6126]')}}</span>
                        <el-select style="width: 80px;" v-model="ECNMaster.ECN_Type_Code">
                            <el-option v-for="(item, index) in ecntypelist" :key="index" :value="item.ECN_Type_Code"
                                       :label="item.ECN_Type_Name"></el-option>
                        </el-select>
                        <span>{{$t('getapi[6150]')}}</span>
                        <el-select style="width: 80px;" v-model="ECNMaster.Product_Stage_Code">
                            <el-option v-for="(item, index) in ecnstagelist" :key="index"
                                       :value="item.Product_Stage_Code" :label="item.Product_Stage_Name"></el-option>
                        </el-select>
                        <span>{{$t('getapi[6138]')}}</span>
                        <el-select style="width: 80px;" v-model="ECNMaster.ECN_Urgency">
                            <el-option v-for="(item, index) in ugenry" :key="index" :value="item.id"
                                       :label="item.name"></el-option>
                        </el-select>
                        <span>{{$t('getapi[552]')}}</span>
                        <el-input v-if="ECNMaster.ECN_Status == 0" :value="$t('getapi[1422]')"  style="width: 130px;"
                                  :readonly="true" class="readO" size="mini"></el-input>
                        <el-input v-if="ECNMaster.ECN_Status == 1" :value="$t('getapi[8718]')"  style="width: 130px;"
                                  :readonly="true" class="readO" size="mini"></el-input>
                        <el-input v-if="ECNMaster.ECN_Status == 2" :value="$t('getapi[5141]')"  style="width: 130px;"
                                  :readonly="true" class="readO" size="mini"></el-input>
                        <el-input v-if="ECNMaster.ECN_Status == 3" :value="$t('getapi[2408]')"  style="width: 130px;"
                                  :readonly="true" class="readO" size="mini"></el-input>
                        <el-input v-if="ECNMaster.ECN_Status == 4" :value="$t('getapi[8719]')"  style="width: 130px;"
                                  :readonly="true" class="readO" size="mini"></el-input>
                        <el-input v-if="ECNMaster.ECN_Status == 5" :value="$t('getapi[5142]')"  style="width: 130px;"
                                  :readonly="true" class="readO" size="mini"></el-input>
                        <el-input v-if="ECNMaster.ECN_Status == 6" :value="$t('getapi[5143]')"  style="width: 130px;"
                                  :readonly="true" class="readO" size="mini"></el-input>
                        <el-input v-if="ECNMaster.ECN_Status == 7" :value="$t('getapi[441]')"  style="width: 130px;"
                                  :readonly="true" class="readO" size="mini"></el-input>
                        <span>{{$t('getapi[6700]')}}</span>
                        <el-input
                                v-model="ECNMaster.itemvernum"
                                :placeholder="$t('getapi[6700]')"
                                style="width: 115px;"
                                size="mini"
                        ></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{$t('getapi[6151]')}}</span>
                        <el-input type="number" @mousewheel.native.prevent v-model="ECNMaster.Annex_Drawing_Num" style="width: 60px;"
                                  size="mini"></el-input>
                        {{$t('getapi[6152]')}}
                        <span>WI</span>
                        <el-input type="number" @mousewheel.native.prevent v-model="ECNMaster.Annex_WI_Num" style="width: 60px;"
                                  size="mini"></el-input>
                        {{$t('getapi[6152]')}}
                        <span>{{$t('getapi[224]')}}</span>
                        <el-input type="number" @mousewheel.native.prevent v-model="ECNMaster.Annex_Other_Num" style="width: 60px;"
                                  size="mini"></el-input>
                        {{$t('getapi[6152]')}}
                        <el-button type="danger" size="mini" style="margin-left: 15px;" @click="closeqz"
                                   :disabled="!btn.colse">{{$t('getapi[2345]')}}
                        </el-button>
                        <el-checkbox v-model="ECNMaster.New_flag" :true-label="'1'" :false-label="'0'">
                            {{$t('getapi[6147]')}}
                        </el-checkbox>
                        <span>{{$t('getapi[6153]')}}</span>
                        <el-input style="width: 130px;" v-model="ECNMaster.ECN_Accept_Person"
                                  @click.native.prevent="showgetpe(0)" readonly></el-input>
                        <span>{{$t('getapi[6154]')}}</span>
                        <el-date-picker
                                v-model="ECNMaster.ECN_Accept_Time"
                                type="date"
                                value-format="yyyy/MM/dd HH:hh:ss"
                                style="width: 130px;"
                                size="mini"
                        ></el-date-picker>
                    </div>
                </div>-->
                {{$t('getapi[6155]')}}：{{ ECNMaster.RoutingStr }}
                <el-tabs>
                    <el-tab-pane :label="$t('getapi[6139]')">
                        <!-- <el-input v-model="ECNMaster.ECN_Description" :rows="20" type="textarea" placeholder="请输入内容" maxlength="3000" show-word-limit></el-input> -->
                        <!--<quill-editor
                                ref="text"
                                v-model="ECNMaster.ECN_Description"
                                class="myQuillEditor"
                                :options="quillOption"

                        />-->
                        <quillEditor class='quillEditorChild' ref='myQuillEditor' v-model="ECNMaster.ECN_Description"
                                   @inputChange="onEditorChange($event)"
                                  :disabled="ECNMaster.ECN_Status >= 3"
                                  :style="{height:tableHeight -150+ 'px'}"> </quillEditor>
                    </el-tab-pane>

                    <el-tab-pane :label="$t('getapi[6156]')">
                        <td style="width:100px;"> <el-button type="primary" size="mini" @click="copyplandate()">{{ $t('getapi[12778]') }}</el-button></td>
                        <!-- 表格 -->
                        <el-table
                                :data="ECNDetail"
                                v-loading="loading"
                                :highlight-current-row="false"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - 160"
                                tab-click="selectInfo(0)"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange"
                                style="width: 100%; margin-top:0px"
                                :header-cell-style="$limits.headerClass"
                        >
                            <el-table-column :label="$t('getapi[6048]')" width="70" align="center" v-if="ECNMaster.ECN_Status == 5">
                                <template slot-scope="scope"> 
                                    <template v-if="(scope.row.checked== true && $limits.fnIsEmpty(scope.row.Complete_Time)) && ((userData.username + '(' + userData.EmpCode + ')') == scope.row.Plan_Person || btn.implement)">
                                        <el-button @click.native.prevent="endbtn(scope)" type="text" size="small" >
                                        {{$t('getapi[6157]')}}
                                    </el-button>
                                    </template>  
                                    <template v-else>
                                        <el-button type="text" size="small" disabled>
                                            {{$t('getapi[6157]')}}
                                        </el-button>
                                    </template>
                                </template>
                            </el-table-column>
                            <el-table-column type="selection" prop="checked" :label="$t('getapi[6158]')">
                                <template scope="scope">
                                    <el-checkbox v-model="scope.row.checked" @change="checkf($event, scope)"
                                                 :disabled="ECNMaster.ECN_Status == 4 || ECNMaster.ECN_Status == 5 || ECNMaster.ECN_Status == 6 || ECNMaster.ECN_Status == 7"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Relation_Strategy_No" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Department_Name"
                                             :label="$t('getapi[6159]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Content"
                                             :label="$t('getapi[6160]')"></el-table-column>
                            <el-table-column prop="ismustfile" :label="$t('getapi[12505]')">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.ismustfile"  @change="checismustfile($event, scope)" :true-label=1 :false-label=0 
                                        :disabled="(ECNMaster.ECN_Status == 4 || ECNMaster.ECN_Status == 5 || ECNMaster.ECN_Status == 6 || ECNMaster.ECN_Status == 7)"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plan_Person" :label="$t('getapi[6161]')">
                                <template scope="scope">
                                    <el-input
                                            type="text"
                                            v-model="scope.row.Plan_Person"
                                            @click.native.prevent="showgetpes(scope)"
                                            readonly
                                            class="mcolor"
                                            v-if="ECNMaster.ECN_Status < 4 && (scope.row.checked == true && scope.row.Content =='压力机模、冲模、工装确认')"
                                    ></el-input>
                                    <el-input
                                            type="text"
                                            v-model="scope.row.Plan_Person"
                                            @click.native.prevent="showgetpes(scope)"
                                            readonly
                                            v-if="ECNMaster.ECN_Status < 4 || (scope.row.checked != true || scope.row.Content =='压力机模、冲模、工装确认')"
                                    ></el-input>
                                    <el-input type="text" v-if="ECNMaster.ECN_Status >= 4"
                                              v-model="scope.row.Plan_Person" readonly></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plan_Time" :label="$t('getapi[6162]')">
                                <template scope="scope">
                                    <el-date-picker
                                            v-model="scope.row.Plan_Time"
                                            type="date"
                                            value-format="yyyy/MM/dd HH:hh:ss"
                                            @blur="checkfclick(scope)"
                                            size="mini"
                                            v-if="ECNMaster.ECN_Status < 4"
                                    ></el-date-picker>

                                    <el-input type="text" v-if="ECNMaster.ECN_Status >= 4"
                                              :value="timd(scope.row.Plan_Time)" readonly></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Complete_Time" :label="$t('getapi[6163]')">
                                <template scope="scope">
                                    <!-- <el-date-picker
                                        v-model="scope.row.Complete_Time"
                                        @blur="checkfclick(scope)"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        type="date"
                                        placeholder="实际完成日期"
                                        size="mini"
                                        v-if="ECNMaster.ECN_Status < 4"
                                    ></el-date-picker> -->
                                    <el-input
                                            :value="timd(scope.row.Complete_Time)"
                                            type="text"
                                            :class="ECNMaster.ECN_Status == '5' && scope.row.checked ? 'bred' : ''"
                                            readonly
                                    ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" :label="$t('getapi[6487]')" width="70">
                                <template slot-scope="scope" v-if="!$limits.fnIsEmpty(scope.row.Relation_ECN_No) && scope.row.ismustfile==1">
                                    <el-button slot="reference" type="text" size="mini" @click.native.prevent="files(scope)" >
                                        {{$t('getapi[6225]')}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 表格 -->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6130]')">
                        <div class="boxs">
                            <div v-for="(items, index) in ecndep" :key="items.Department_No">
                                <el-checkbox v-model="items.checked" @change="ecndeps">{{ items.Department_Name }}
                                </el-checkbox>
                                <el-input
                                        v-model="items.remark"
                                        @click.native.prevent="showgetpess(index)"
                                        :disabled="ECNMaster.ECN_Status >= 1"
                                        style="width: 130px;"
                                        size="mini"
                                        v-if="ECNMaster.ECN_Status == 0 || ECNMaster.ECN_Status == 2"
                                ></el-input>
                                <el-input v-model="items.remark" style="width: 130px;" size="mini" readonly
                                          v-else></el-input>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6164]')">
                        <!-- 表格 -->
                        <el-table
                                :data="proyx"
                                v-loading="loading"
                                :highlight-current-row="false"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="215"
                                tab-click="selectInfo(0)"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column show-overflow-tooltip prop="name" label=""></el-table-column>
                            <el-table-column prop="Plate_Part_Code" align="center"
                                             :label="$t('getapi[112]')">
                                <template scope="scope">
                                    <el-input
                                            v-if="scope.$index < 6 && (ECNMaster.ECN_Status == 0 || ECNMaster.ECN_Status == 2)"
                                            type="text"
                                            v-model="scope.row.Plate_Part_Code"
                                            @click.native.prevent="showitems(scope)"
                                    ></el-input>
                                    <el-input
                                            v-if="scope.$index < 6 && ECNMaster.ECN_Status != 0 && ECNMaster.ECN_Status != 2"
                                            type="text"
                                            v-model="scope.row.Plate_Part_Code"
                                            disabled
                                    ></el-input>
                                    {{ scope.row.Plate_Part_Code }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plate_Part_Version" align="center"
                                             :label="$t('getapi[149]')">
                                <template scope="scope">
                                    <el-input
                                            v-if="scope.$index < 6 && (ECNMaster.ECN_Status == 0 || ECNMaster.ECN_Status == 2)"
                                            type="text"
                                            v-model="scope.row.Plate_Part_Version"
                                            @click.native.prevent="showitems(scope)"
                                    ></el-input>
                                    <el-input
                                            v-if="scope.$index < 6 && ECNMaster.ECN_Status != 0 && ECNMaster.ECN_Status != 2"
                                            type="text"
                                            v-model="scope.row.Plate_Part_Version"
                                            disabled
                                    ></el-input>
                                    {{ scope.row.Plate_Part_Version }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plate_Onway_Num" align="right"
                                             :label="$t('getapi[1620]')">
                                <template scope="scope">
                                    <input :disabled="ECNMaster.ECN_Status != 0 && ECNMaster.ECN_Status != 2"
                                           type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Plate_Onway_Num"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plate_Deal_With" align="center"
                                             :label="$t('getapi[6165]')">
                                <template scope="scope">
                                    <el-select style="width: 80px;" v-model="scope.row.Plate_Deal_With">
                                        <el-option value="0" label="用完为止"></el-option>
                                        <el-option value="1" label="返工返修"></el-option>
                                        <el-option value="2" label="报废"></el-option>
                                        <el-option value="3" label="返供应商"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plate_Stock_Num" align="right"
                                             :label="$t('getapi[6166]')">
                                <template scope="scope">
                                    <input :disabled="ECNMaster.ECN_Status != 0 && ECNMaster.ECN_Status != 2"
                                           type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Plate_Stock_Num"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Procurement_Deal_With" align="center"
                                             :label="$t('getapi[6165]')">
                                <template scope="scope">
                                    <el-select style="width: 80px;" v-model="scope.row.Procurement_Deal_With">
                                        <el-option value="0" :label="$t('getapi[8720]')"></el-option>
                                        <el-option value="1" :label="$t('getapi[8685]')"></el-option>
                                        <el-option value="2" :label="$t('getapi[8686]')"></el-option>
                                        <el-option value="3" :label="$t('getapi[8687]')"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plate_Price" align="right"
                                             :label="$t('getapi[1410]')">
                                <template scope="scope">
                                    <input :disabled="ECNMaster.ECN_Status != 0 && ECNMaster.ECN_Status != 2"
                                           type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Plate_Price"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plate_Mold_Cost" align="right"
                                             :label="$t('getapi[6167]')">
                                <template scope="scope">
                                    <input :disabled="ECNMaster.ECN_Status != 0 && ECNMaster.ECN_Status != 2"
                                           type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Plate_Mold_Cost"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plate_Amount" align="right"
                                             :label="$t('getapi[6168]')">
                                <template scope="scope">
                                    <input :disabled="ECNMaster.ECN_Status != 0 && ECNMaster.ECN_Status != 2"
                                           type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.Plate_Amount"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Plate_Bear" align="center"
                                             :label="$t('getapi[6169]')">
                                <template scope="scope">
                                    <el-select style="width: 80px;" v-model="scope.row.Plate_Bear">
                                        <el-option value="0" :label="$t('getapi[8721]')"></el-option>
                                        <el-option value="1" :label="$t('getapi[8722]')"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 表格 -->
                        <div style="margin-top:2px;">
                            <span style="color:red">{{$t('getapi[8723]')}}</span>
                        </div>
                        <table>
                            <tr>
                                <td>{{$t('getapi[163]')}}</td>
                                <td>
                                    <routejump :urlNo="6">
                                    <el-input
                                            v-model="ECNMaster.Planner"
                                            style="width: 130px;"
                                            size="mini"
                                            @click.native.prevent="showgetpe(1)"
                                            :disabled="ECNMaster.ECN_Status > 1"
                                    ></el-input>
                                    </routejump>
                                </td>
                                <td>{{$t('getapi[6170]')}}</td>
                                <td>
                                    <el-date-picker
                                            v-model="ECNMaster.Planner_Affirm"
                                            type="date"
                                            value-format="yyyy/MM/dd HH:hh:ss"
                                            style="width: 130px;"
                                            size="mini"
                                            disabled
                                    ></el-date-picker>
                                </td>
                                <td>
                                    <el-button size="mini" :disabled="ECNMaster.ECN_Status != 1 || (((user + '(' + userData.EmpCode + ')') != ECNMaster.Planner) && (ECNMaster.PlannerSFlag == false))" type="success"
                                               style="margin-left: 15px;" @click="savas(2)">{{$t('getapi[2051]')}}
                                    </el-button>
                                    <span>{{$t('getapi[6171]')}}</span>
                                    <el-input v-model="Plate_Mold_Costs" disabled style="width: 80px;"
                                              size="mini"></el-input>
                                    <el-input v-model="Plate_Amounts" disabled style="width: 80px;" size="mini"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[6172]')}}</td>
                                <td colspan="4">
                                    <el-input v-model="ECNMaster.Planner_remark" type="textarea" :rows="1" style="width:80%"
                                              show-word-limit></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[6173]')}}</td>
                                <td>
                                    <el-input v-model="ECNMaster.Original_Price" style="width: 130px;"
                                              size="mini"></el-input>
                                </td>
                                <td>{{$t('getapi[6174]')}}</td>
                                <td>
                                    <el-input v-model="ECNMaster.Current_Price" style="width: 130px;"
                                              size="mini"></el-input>
                                </td>
                                <td>
                                    <el-checkbox v-model="ECNMaster.Client_Accept" :true-label="0" :false-label="1" style="margin-left:8px">
                                        {{$t('getapi[6175]')}}
                                    </el-checkbox>
                                    <span style="margin-left:8px">{{$t('getapi[6154]')}}</span>
                                    <el-date-picker
                                            v-model="ECNMaster.Client_Accept_Time"
                                            type="date"
                                            value-format="yyyy/MM/dd HH:hh:ss"
                                            :disabled="!editf"
                                            style="width: 130px;"
                                            size="mini"
                                    ></el-date-picker>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[6140]')}}</td>
                                <td>
                                    <el-input v-model="ECNMaster.Create_Person" style="width: 130px;"
                                              size="mini"></el-input>
                                </td>
                                <td>{{$t('getapi[6141]')}}</td>
                                <td>
                                    <el-date-picker
                                            v-model="ECNMaster.Create_Time"
                                            type="date"
                                            value-format="yyyy/MM/dd HH:hh:ss"
                                            style="width: 130px;"
                                            size="mini"
                                            :disabled="true"
                                    ></el-date-picker>
                                </td>
                                <td>
                                    <el-button
                                            v-if="ECNMaster.ECN_Status == 0 && ((ECNMaster.Create_Person.indexOf(user) >= 0) || (ECNMaster.Create_PersonSFlag == true)) && ECNMaster.ECN_No"
                                            size="mini"
                                            type="danger"
                                            style="margin-left: 15px;"
                                            @click="savas(1)"
                                            :loading="savasLoading"
                                    >
                                        {{$t('getapi[6176]')}}
                                    </el-button>
                                    <el-button v-else size="mini" type="danger" style="margin-left: 15px;" disabled>
                                        {{$t('getapi[6176]')}}
                                    </el-button>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[550]')}}</td>
                                <td>
                                    <routejump :urlNo="6">
                                    <el-input v-model="ECNMaster.Audit_Person" style="width: 130px;" size="mini" readonly>
                                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee(1)"></i>
                                    </el-input>
                                    </routejump>
                                </td>
                                <td>{{$t('getapi[742]')}}</td>
                                <td>
                                    <el-date-picker
                                            v-model="ECNMaster.Audit_Time"
                                            type="date"
                                            value-format="yyyy/MM/dd HH:hh:ss"
                                            style="width: 130px;"
                                            size="mini"
                                            :disabled="true"
                                    ></el-date-picker>
                                </td>
                                <td>
                                    <el-button :disabled="ECNMaster.ECN_Status != 2 || (((user + '(' + userData.EmpCode + ')') != ECNMaster.Audit_Person) && (ECNMaster.Audit_PersonSFlag == false))" size="mini" type="danger"
                                               style="margin-left: 15px;" @click="savas(3)">{{$t('getapi[941]')}}
                                    </el-button>
                                    <el-button :disabled="ECNMaster.ECN_Status != 3 || (((user + '(' + userData.EmpCode + ')') != ECNMaster.Audit_Person) && (ECNMaster.Audit_PersonSFlag == false))" size="mini" type="danger"
                                               style="margin-left: 15px;" @click="savas(2)">{{$t('getapi[1334]')}}
                                    </el-button>
                                    <el-button :disabled="ECNMaster.ECN_Status != 2 || (((user + '(' + userData.EmpCode + ')') != ECNMaster.Audit_Person) && (ECNMaster.Audit_PersonSFlag == false))" size="mini" type="danger"
                                               style="margin-left: 15px;" @click="reject(1)">{{$t('getapi[5161]')}}
                                    </el-button>
                                    <span>{{ECNMaster.RejectStr1}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[1602]')}}</td>
                                <td>
                                    <routejump :urlNo="6">
                                    <el-input v-model="ECNMaster.Confirm_Person" style="width: 130px;" size="mini" readonly>
                                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee(2)"></i>
                                    </el-input>
                                    </routejump>
                                </td>
                                <td>{{$t('getapi[576]')}}</td>
                                <td>
                                    <el-date-picker
                                            v-model="ECNMaster.Confirm_Time"
                                            type="date"
                                            value-format="yyyy/MM/dd HH:hh:ss"
                                            style="width: 130px;"
                                            size="mini"
                                            :disabled="true"
                                    ></el-date-picker>
                                </td>
                                <td>
                                    <el-button :disabled="ECNMaster.ECN_Status != 3 || (((user + '(' + userData.EmpCode + ')') != ECNMaster.Confirm_Person) && (ECNMaster.Confirm_PersonSFlag == false))" size="mini" type="danger"
                                               style="margin-left: 15px;" @click="savas(4)">{{$t('getapi[6177]')}}
                                    </el-button>
                                    <el-button :disabled="ECNMaster.ECN_Status != 3 || (((user + '(' + userData.EmpCode + ')') != ECNMaster.Confirm_Person) && (ECNMaster.Confirm_PersonSFlag == false))" size="mini" type="danger"
                                               style="margin-left: 15px;" @click="reject(2)">{{$t('getapi[5161]')}}
                                    </el-button>
                                    <span>{{ECNMaster.RejectStr2}}</span>
                                </td>
                            </tr>
                        </table>
                        <!--<div class="box" style="height:300px">
                            <div class="bbl">
                                <span>{{$t('getapi[163]')}}</span>
                                <el-input
                                        v-model="ECNMaster.Planner"
                                        style="width: 130px;"
                                        size="mini"
                                        @click.native.prevent="showgetpe(1)"
                                        :disabled="ECNMaster.ECN_Status > 1"
                                ></el-input>
                                <span>{{$t('getapi[6170]')}}</span>
                                <el-date-picker
                                        v-model="ECNMaster.Planner_Affirm"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        style="width: 130px;"
                                        size="mini"
                                        disabled
                                ></el-date-picker>
                                <el-button size="mini" :disabled="ECNMaster.ECN_Status != 1 || (user + '(' + userData.EmpCode + ')') != ECNMaster.Planner" type="success"
                                           style="margin-left: 15px;" @click="savas(2)">{{$t('getapi[2051]')}}
                                </el-button>
                                <span>{{$t('getapi[6171]')}}</span>
                                <el-input v-model="Plate_Mold_Costs" disabled style="width: 80px;"
                                          size="mini"></el-input>
                                <el-input v-model="Plate_Amounts" disabled style="width: 80px;" size="mini"></el-input>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[6172]')}}</span>
                                <el-input v-model="ECNMaster.Planner_remark" type="textarea" :rows="1" style="width:80%"
                                          show-word-limit></el-input>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[6173]')}}</span>
                                <el-input v-model="ECNMaster.Original_Price" style="width: 130px;"
                                          size="mini"></el-input>
                                <span>{{$t('getapi[6174]')}}</span>
                                <el-input v-model="ECNMaster.Current_Price" style="width: 130px;"
                                          size="mini"></el-input>
                                <el-checkbox v-model="ECNMaster.Client_Accept" :true-label="0" :false-label="1">
                                    {{$t('getapi[6175]')}}
                                </el-checkbox>
                                <span>{{$t('getapi[6154]')}}</span>
                                <el-date-picker
                                        v-model="ECNMaster.Client_Accept_Time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        :disabled="!editf"
                                        style="width: 130px;"
                                        size="mini"
                                ></el-date-picker>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[6140]')}}</span>
                                <el-input v-model="ECNMaster.Create_Person" style="width: 130px;"
                                          size="mini"></el-input>
                                <span>{{$t('getapi[6141]')}}</span>
                                <el-date-picker
                                        v-model="ECNMaster.Create_Time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        style="width: 130px;"
                                        size="mini"
                                        :disabled="true"
                                ></el-date-picker>
                                <el-button
                                        v-if="ECNMaster.ECN_Status == 0 && ECNMaster.Create_Person.indexOf(user) >= 0 && ECNMaster.ECN_No"
                                        size="mini"
                                        type="danger"
                                        style="margin-left: 15px;"
                                        @click="savas(1)"
                                >
                                    {{$t('getapi[6176]')}}
                                </el-button>
                                <el-button v-else size="mini" type="danger" style="margin-left: 15px;" disabled>
                                    {{$t('getapi[6176]')}}
                                </el-button>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[550]')}}</span>
                                <el-input v-model="ECNMaster.Audit_Person" style="width: 130px;" size="mini" readonly>
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee(1)"></i>
                                </el-input>
                                <span>{{$t('getapi[742]')}}</span>
                                <el-date-picker
                                        v-model="ECNMaster.Audit_Time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        style="width: 130px;"
                                        size="mini"
                                        :disabled="true"
                                ></el-date-picker>
                                <el-button :disabled="ECNMaster.ECN_Status != 2 || (user + '(' + userData.EmpCode + ')') != ECNMaster.Audit_Person" size="mini" type="danger"
                                           style="margin-left: 15px;" @click="savas(3)">{{$t('getapi[941]')}}
                                </el-button>
                                <el-button :disabled="ECNMaster.ECN_Status != 3 || (user + '(' + userData.EmpCode + ')') != ECNMaster.Audit_Person" size="mini" type="danger"
                                           style="margin-left: 15px;" @click="savas(2)">{{$t('getapi[1334]')}}
                                </el-button>
                                <el-button :disabled="ECNMaster.ECN_Status != 2 || (user + '(' + userData.EmpCode + ')') != ECNMaster.Audit_Person" size="mini" type="danger"
                                           style="margin-left: 15px;" @click="reject(1)">{{$t('getapi[5161]')}}
                                </el-button>
                                <span>{{ECNMaster.RejectStr1}}</span>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[1602]')}}</span>
                                <el-input v-model="ECNMaster.Confirm_Person" style="width: 130px;" size="mini" readonly>
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee(2)"></i>
                                </el-input>
                                <span>{{$t('getapi[576]')}}</span>
                                <el-date-picker
                                        v-model="ECNMaster.Confirm_Time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        style="width: 130px;"
                                        size="mini"
                                        :disabled="true"
                                ></el-date-picker>
                                <el-button :disabled="ECNMaster.ECN_Status != 3 || (user + '(' + userData.EmpCode + ')') != ECNMaster.Confirm_Person" size="mini" type="danger"
                                           style="margin-left: 15px;" @click="savas(4)">{{$t('getapi[6177]')}}
                                </el-button>
                                <el-button :disabled="ECNMaster.ECN_Status != 3 || (user + '(' + userData.EmpCode + ')') != ECNMaster.Confirm_Person" size="mini" type="danger"
                                           style="margin-left: 15px;" @click="reject(2)">{{$t('getapi[5161]')}}
                                </el-button>
                                <span>{{ECNMaster.RejectStr2}}</span>
                            </div>
                        </div>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6178]')">
                        <div class="btnnowrap">
                            <el-button type="primary" v-if="IsLoginDB_MY=='my'" :disabled="!btn.delsign" @click="addSign('')" size="mini" >{{ $t('getapi[12841]') }}</el-button>
                            <el-button type="primary" v-if="IsLoginDB_MY=='my'" size="mini" :disabled="!btn.delsign" @click="delline" >{{$t('getapi[4097]') }}</el-button>
                        </div>
                        <!-- 表格 -->
                        <el-table
                                :data="ecnper"
                                v-loading="loading"
                                :highlight-current-row="false"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - 215"
                                tab-click="selectInfo(0)"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange_Ecnper"
                                style="width: 100%; margin-top:0px"
                                :header-cell-style="$limits.headerClass"
                                
                        >
                            <el-table-column type="selection" align="center" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Signature_Strategy_No" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="role_name"
                                             :label="$t('getapi[6179]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="user_name"
                                             :label="$t('getapi[1191]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Opinion"
                                             :label="$t('getapi[6180]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Opinion_Time"
                                             :label="$t('getapi[6181]')"></el-table-column>
                            <el-table-column prop="opinion_status" :label="$t('getapi[552]')">
                                <template slot-scope="scope">
                                    <el-input v-show="scope.row.opinion_status == -1" :value="$t('getapi[8724]')" disabled></el-input>
                                    <el-input v-show="scope.row.opinion_status == 0" :value="$t('getapi[6188]')" disabled></el-input>
                                    <el-input v-show="scope.row.opinion_status == 1" :value="$t('getapi[6187]')" disabled></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('getapi[6048]')" width="70" align="center">
                                <template slot-scope="scope">
                                    <el-button v-if="ECNMaster.ECN_Status == 4" @click.native.prevent="hq(scope)"
                                               type="text" size="small" :disabled="scope.row.superior_flag == 0">
                                        {{$t('getapi[6048]')}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 表格 -->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[224]')">
                        <div class="box" :style="{ height: tableHeight - 215 + 'px' }">
                            <div class="bbl">
                                <span>{{$t('getapi[6182]')}}</span>
                                <el-input v-model="ECNMaster.ECN_Produce_Person" style="width: 130px;" size="mini"
                                          @click.native.prevent="showgetpe(2)"></el-input>
                                <span>{{$t('getapi[6183]')}}</span>
                                <el-date-picker
                                        v-model="ECNMaster.ECN_Produce_Time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        style="width: 130px;"
                                        size="mini"
                                ></el-date-picker>
                                <el-button size="mini" :disabled="ECNMaster.ECN_Status != 6" type="danger"
                                           style="margin-left: 15px;" @click="savas(8)">{{$t('getapi[2051]')}}
                                </el-button>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[6184]')}}</span>
                                <el-input v-model="ECNMaster.ECN_Purchase_Person" style="width: 130px;" size="mini"
                                          @click.native.prevent="showgetpe(3)"></el-input>
                                <span>{{$t('getapi[6185]')}}</span>
                                <el-date-picker
                                        v-model="ECNMaster.ECN_Purchase_Time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        style="width: 130px;"
                                        size="mini"
                                ></el-date-picker>
                                <el-button :disabled="ECNMaster.ECN_Status != 6" size="mini" type="danger"
                                           style="margin-left: 15px;" @click="savas(9)">{{$t('getapi[2051]')}}
                                </el-button>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[143]')}}</span>
                                <el-input v-model="ECNMaster.ECN_Notes" type="textarea" :rows="5" style="width:80%"
                                          show-word-limit></el-input>
                            </div>
                            <div class="bbl">
                                <span>{{$t('getapi[6143]')}}</span>
                                <el-date-picker
                                        v-model="ECNMaster.ECN_Close_Time"
                                        type="date"
                                        value-format="yyyy/MM/dd HH:hh:ss"
                                        style="width: 130px;"
                                        size="mini"
                                        :disabled="ECNMaster.ECN_Status != 6"
                                ></el-date-picker>
                                <span>{{$t('getapi[5020]')}}</span>
                                <el-input v-model="ECNMaster.ECN_Close_Person" style="width: 130px;"
                                          size="mini"></el-input>
                                <el-button :disabled="ECNMaster.ECN_Status != 6" size="mini" type="danger"
                                           style="margin-left: 15px;" @click="savas(7)">{{$t('getapi[441]')}}
                                </el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[13039]')">
                        <div class="btnnowrap">
                            <el-button type="primary" :disabled="!btn.delpart"  @click="addpart('')" size="mini" >{{ $t('getapi[878]') }}</el-button>
                            <el-button type="primary" :disabled="!btn.delpart" size="mini" @click="delpart" >{{$t('getapi[3889]') }}</el-button>
                        </div>
                        <!-- 表格 -->
                        <el-table
                                :data="PartLists"
                                v-loading="loading"
                                :highlight-current-row="false"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - 215"
                                tab-click="selectInfo(0)"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange_Ecnper"
                                style="width: 100%; margin-top:0px"
                                :header-cell-style="$limits.headerClass"
                                
                        >
                            <el-table-column type="selection" align="center" width="20"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="relation_ecn_no" label="ID"
                                             v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_code"
                                             :label="$t('getapi[112]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version"
                                             :label="$t('getapi[149]')" width="80"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="page_no"
                                             :label="$t('getapi[127]')" width="80"></el-table-column>
                        </el-table>
                        <!-- 表格 -->
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="PageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="ECNViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6125]')" queryData="ECNViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 搜索弹框 -->
        <!-- 客户弹框 -->
        <selector :isVisible="false" :selectType="2" :isSplitPage="true" :postUrl="'Basic/Popup/GetSALCustomerDataList'"
                  @callback="getsal" ref="setsal"></selector>
        <!-- 头物料弹框 -->
        <selector :isVisible="false" :selectType="13" :isSplitPage="true" :postUrl="'Basic/Popup/GetPartPopuDataList'"
                  @callback="getitem" ref="setitem"></selector>
        <selector :isVisible="false" :selectType="13" :isSplitPage="true" :postUrl="'Basic/Popup/GetPartPopuDataList'"
                  @callback="getitems" ref="setitems"></selector>
        <!-- 头接受人 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getper" ref="setper"></selector>
        <!-- ecn实施计划负责人 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getpers" ref="setpers"></selector>
        <!-- 审核人 批准人 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getEmployee" ref="employee"></selector>
        <!-- 分发部门 -->
        <selector :isVisible="false" :selectType="8" :isSplitPage="true" :postUrl="'Basic/Popup/GetEmployeeDataList'"
                  @callback="getperss" ref="setperss"></selector>
        <!-- 会签人员 -->
        <selector :isVisible="signVisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Basic/ECN/GetECNSignatureStrategyPopuDataList'" @callback="getSignlist" ref="setsignlist"></selector>
        <!-- 添加物料 -->
        <selector :isVisible="partVisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Eng/ECN/GetEcnPartMasterPopupList'" @callback="getPartlist" ref="setpartlist"></selector>
        <!-- 会签弹框 -->
        <el-dialog v-dialogDrag center :title="$t('getapi[6186]')" :visible.sync="dialogVisible" width="30%">
            <el-input v-model="sign.Opinion" type="textarea" :rows="5" show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="hqbtn(0)" :disabled="hqbtnLoading">{{$t('getapi[6187]')}}</el-button>
				<el-button type="warning" @click="hqbtn(1)" :disabled="hqbtnLoading">{{$t('getapi[6188]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isShowDialog" :title="$t('getapi[8126]')" width="25%" :close-on-click-modal="false">
            <el-input type="textarea" v-model="RejectStr1" rows="22" v-if="RejectType == 1"></el-input>
            <el-input type="textarea" v-model="RejectStr2" rows="22" v-if="RejectType == 2"></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowDialog = false">{{ $t('getapi[2054]') }}</el-button>
                <el-button type="primary" size="mini" @click="confirmReject(1)" v-if="RejectType == 1">{{ $t('getapi[937]') }}</el-button>
                <el-button type="primary" size="mini" @click="confirmReject(2)" v-if="RejectType == 2">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        
        <el-dialog v-dialogDrag :visible.sync="isVisiblefile" :title="$t('getapi[6225]')" width="50%">
            <div style="display: flex">
                <el-upload :show-file-list="false" class="upload-demo"
                           :data="fileparm"
                           :action="fileurl"
                           :on-change="handleChange"
                           :on-success="handleSuccess">
                    <el-button size="mini" type="primary">{{$t('getapi[3591]')}}</el-button>
                </el-upload>
                <!-- <el-button size="mini" type="primary" @click="addline" style="margin-left: 8px">{{$t('getapi[878]')}}</el-button>
                <el-button size="mini" type="primary" @click="batchdel" :disabled="selectData.length < 1">{{$t('getapi[40]')}}</el-button> -->
            </div>
            <el-table :data="FileLists" border height="400" size="mini" style="width: 100%;"
                      header-row-class-name="headerclass"
                      @selection-change="handleSelectionChange"
                      :row-class-name="tableRowClassName">
                <!-- <el-table-column type="selection"></el-table-column> -->
                <el-table-column show-overflow-tooltip prop="filename" :label="$t('getapi[3590]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="doc_type" :label="$t('getapi[3605]')" width="80"></el-table-column>
                <el-table-column show-overflow-tooltip prop="doc_size" :label="$t('getapi[7875]')" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="upload_person" :label="$t('getapi[6425]')" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="upload_time" :label="$t('getapi[6426]')" width="130"></el-table-column>
                <el-table-column show-overflow-tooltip prop="path" :label="$t('getapi[7952]')" width="100"></el-table-column>
                <el-table-column align="center" :label="$t('getapi[6048]')" width="100">
                    <template slot-scope="scope">
                        <el-button slot="reference" type="text" size="small"  @click.native.prevent="lookfiles(scope)">{{$t('getapi[3558]')}}</el-button>
                        <el-button slot="reference" type="text" size="small" v-if="scope.row.upload_person==user"  @click.native.prevent="filedel(scope)">{{$t('getapi[40]')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisiblefile = false">{{$t('getapi[441]')}}</el-button>
				<!-- <el-button type="primary" @click="saveFile">{{$t('getapi[937]')}}</el-button> -->
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import Quill from 'quill';
    import {quillEditor} from 'vue-quill-editor';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import {container, ImageExtend} from 'quill-image-extend-module';
    import { Loading } from 'element-ui';    
    Quill.register('modules/ImageExtend', ImageExtend);
    import quillConfig from '@/utils/config.js';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'

    export default {
        name: 'ecnlist',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                /* 富文本参考网站:https://blog.csdn.net/weixin_43888129/article/details/103888623 */
                quillOption: quillConfig,
                IsEdit: 1,
                dialogVisible: false, //会签谈框
                sign: {
                    Relation_ECN_No: '',
                    Relation_Signature_Strategy_No: '',
                    Opinion_Person: '',
                    Opinion: '',
                    Opinion_Time: '',
                    Role_name: '',
                    User_name: '',
                    Opinion_status: 0,
                    superior_flag: 0
                },
                Type: 0,
                ECNDetail: [],
                ECNSignature: [],
                PartLists:[],
                ECNMaster: {
                    ECN_No: '',
                    Part_Code: '',
                    Part_Version: '',
                    ECN_Status: '0',
                    ECN_Source: '',
                    Client_Name: '',
                    Product_Name: '',
                    Client_ECN_No: '',
                    ECN_Type_Code: '',
                    Product_Stage_Code: '',
                    ECN_Urgency: '',
                    ECN_Description: '',
                    ECN_Accept_Time: null,
                    ECN_Accept_Person: '',
                    Client_Confirm: '',
                    Annex_Drawing_Num: '',
                    Annex_WI_Num: '',
                    Annex_Other_Num: '',
                    Plate_Part_Code_1: '',
                    Plate_Part_Version_1: '',
                    Plate_Onway_Num_1: '',
                    Plate_Stock_Num_1: '',
                    Plate_Deal_With_1: '',
                    Plate_Price_1: '',
                    Plate_Mold_Cost_1: '',
                    Plate_Amount_1: '',
                    Plate_Bear_1: '',
                    Plate_Part_Code_2: '',
                    Plate_Part_Version_2: '',
                    Plate_Onway_Num_2: '',
                    Plate_Stock_Num_2: '',
                    Plate_Deal_With_2: '',
                    Plate_Price_2: '',
                    Plate_Mold_Cost_2: '',
                    Plate_Amount_2: '',
                    Plate_Bear_2: '',
                    Plate_Part_Code_3: '',
                    Plate_Part_Version_3: '',
                    Plate_Onway_Num_3: '',
                    Plate_Stock_Num_3: '',
                    Plate_Deal_With_3: '',
                    Plate_Price_3: '',
                    Plate_Mold_Cost_3: '',
                    Plate_Amount_3: '',
                    Plate_Bear_3: '',
                    Procurement_Part_Code_1: '',
                    Procurement_Part_Version_1: '',
                    Procurement_Onway_Num_1: '',
                    Procurement_Stock_Num_1: '',
                    Procurement_Deal_With_1: '',
                    Procurement_Price_1: '',
                    Procurement_Mold_Cost_1: '',
                    Procurement_Amount_1: '',
                    Procurement_Bear_1: '',
                    Procurement_Part_Code_2: '',
                    Procurement_Part_Version_2: '',
                    Procurement_Onway_Num_2: '',
                    Procurement_Stock_Num_2: '',
                    Procurement_Deal_With_2: '',
                    Procurement_Price_2: '',
                    Procurement_Mold_Cost_2: '',
                    Procurement_Amount_2: '',
                    Procurement_Bear_2: '',
                    Procurement_Part_Code_3: '',
                    Procurement_Part_Version_3: '',
                    Procurement_Onway_Num_3: '',
                    Procurement_Stock_Num_3: '',
                    Procurement_Deal_With_3: '',
                    Procurement_Price_3: '',
                    Procurement_Mold_Cost_3: '',
                    Procurement_Amount_3: '',
                    Procurement_Bear_3: '',
                    Making_Onway_Num: '',
                    Making_Stock_Num: '',
                    Making_Deal_With: '',
                    Making_Price: '',
                    Making_Mold_Cost: '',
                    Making_Amount: '',
                    Making_Bear: '',
                    Product_Onway_Num: '',
                    Product_Stock_Num: '',
                    Product_Deal_With: '',
                    Product_Price: '',
                    Product_Mold_Cost: '',
                    Product_Amount: '',
                    Product_Bear: '',
                    Planner: '',
                    Planner_remark: '',
                    Planner_Affirm: '',
                    Original_Price: '',
                    Current_Price: '',
                    Client_Accept: '',
                    Client_Accept_Time: null,
                    Create_Person: '',
                    Create_Time: null,
                    Audit_Person: '',
                    Audit_Time: null,
                    Confirm_Person: '',
                    Confirm_Time: null,
                    ECN_Produce_Person: '',
                    ECN_Produce_Time: '',
                    ECN_Purchase_Person: '',
                    ECN_Purchase_Time: null,
                    ECN_Notes: '',
                    Department: '',
                    ECN_Close_Time: null,
                    ECN_Close_Person: this.user,
                    Modify_Person: '',
                    Modify_Time: new Date(),
                    Plate_Deal_With_1_0: '',
                    Plate_Deal_With_2_0: '',
                    Plate_Deal_With_3_0: '',
                    Procurement_Deal_With_1_0: '',
                    Procurement_Deal_With_2_0: '',
                    Procurement_Deal_With_3_0: '',
                    Making_Deal_With_0: '',
                    Product_Deal_With_0: '',
                    RoutingStr: '',
                    New_flag: '',
                    itemvernum: '',
                    RejectStr1: '',
                    RejectStr2: ''
                },
                ecnno: '',
                ecnno1: '',
                ecnno2: '',
                ids: '',
                rowindx: 0, //ecn实施计划负责人弹框下标
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('ecnlist'),
                SelectIndex: 0,
                SelectIndexs: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: [], // 右侧选择的数据的ID集合
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                //isEdit: true, // 是否新增
                itevisible: false, //物料弹框
                rouvisible: false,
                roushowindex: 0,
                wcentervisible: false,
                wcentershowindex: 0,
                editf: true,
                currentRow: null,
                lineid: [],
                userData: [], //用户信息
                user: '', //当前用户
                SuperiorName: '', //ecn有权限实施人员
                btn: {
                    //明细行删除
                    rowdel: false,
                    colse: false,
                    implement: false, // 是否可以实施
                    delsign:false,//删除会签人员
                    delpart:false,//删除物料
                },
                canmove: true, //可以流转
                ecnitem: [], //实施条目
                ecndep: [], //分发部门
                ecnper: [], //会签人员
                ecnnolist: [], //ecnno
                ecntypelist: [],
                ecnstagelist: [],
                proyx: [
                    {
                        name: '特殊板材1',
                        Plate_Part_Code: '',
                        Plate_Part_Version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊板材2',
                        Plate_Part_Code: '',
                        Plate_Part_Version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊板材3',
                        Plate_Part_Code: '',
                        Plate_Part_Version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊采购件1',
                        Plate_Part_Code: '',
                        Plate_Part_Version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊采购件2',
                        Plate_Part_Code: '',
                        Plate_Part_Version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '特殊采购件3',
                        Plate_Part_Code: '',
                        Plate_Part_Version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '在制品',
                        Plate_Part_Code: '',
                        Plate_Part_Version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    },
                    {
                        name: '成品',
                        Plate_Part_Code: '',
                        Plate_Part_Version: '',
                        Plate_Onway_Num: '',
                        Plate_Stock_Num: '',
                        Plate_Deal_With: '0',
                        Procurement_Deal_With: '0',
                        Plate_Price: '',
                        Plate_Mold_Cost: '',
                        Plate_Amount: '',
                        Plate_Bear: '0'
                    }
                ], //产品影响基础
                Plate_Mold_Costs: '', //总计
                Plate_Amounts: '', //总计
                ugenry: [
                    {
                        id: '0',
                        name: '一般'
                    },
                    {
                        id: '1',
                        name: '紧急'
                    }
                ],
                timeId: null,
                code: '',
                isShowDialog: false,
                RejectType: 1,
                RejectStr1: '',
                RejectStr2: '',
                fileurl:'',
                isVisiblefile: false,
                fileparm: {
                    Code: '',
                    Data_Type: 13,//ECN证明材料
                    Login_Group:'',
                    Login_DB:'',
                    Relation_ECN_No: '',
                    Relation_Strategy_No: '',
                },
                FileLists:[],
                FileList:[],
                Login_Group:'',
                Login_DB:'',
                scrollTop:0,
                //实施条目计划负责人是否启用
                setplanuser:0,
                signVisible: false,
                partVisible:false,
                IsLoginDB_MY:'',
                selectData: [],
                savasLoading: false, //执行审核流程操作时，按钮防止多次点击
                hqbtnLoading: false, //会签操作时，按钮防止多次点击
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if(form.name=='home' && Object.keys(vm.$store.state.sharedParams).length > 0){
                    const data = {...vm.$store.state.sharedParams};
                    let arr = []
                    arr.push({
                        query_Condition: data.code,
                        query_field_name: "ECN_No",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    let parm = {
                        PageIndex: vm.PageIndex,
                        PageSize: vm.PageSize,
                        SelectIndex: vm.SelectIndex,
                        Param: arr
                    };
                    vm.$http.urlpost('/Eng/ECN/ECNList', parm, function (res) {
                        if (res.Success == 1) {
                            vm.datajson = res.DataContent;
                            vm.total = res.Totals;
                            vm.DbTbNames = res.DbTbNames;
                            if(vm.datajson.length == 1){
                                setTimeout(() => {
                                    vm.openEdit()
                                    vm.getdlist(data.code, '', '');
                                }, 500);
                            }
                        }
                        vm.loading = false;
                    });
                    vm.$store.commit('clearSharedParams')
                }
                else if((form.name=='wi&iiinfo'||form.name=='wi&iidetail') && Object.keys(vm.$store.state.sharedParams).length > 0){
                    const data = {...vm.$store.state.sharedParams};
                    let arr = []
                    arr.push({
                        query_Condition: data.part_code,
                        query_field_name: "Part_Code",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    arr.push({
                        row_sign:0,
                        query_Condition:"",
                        query_sort:"降序",
                        query_field_type:"date",
                        query_field_name:"Create_Time"
                    })
                    let parm = {
                        PageIndex: vm.PageIndex,
                        PageSize: vm.PageSize,
                        SelectIndex: vm.SelectIndex,
                        Param: arr
                    };
                    vm.$http.urlpost('/Eng/ECN/ECNList', parm, function (res) {
                        if (res.Success == 1) {
                            vm.datajson = res.DataContent;
                            vm.total = res.Totals;
                            vm.DbTbNames = res.DbTbNames;
                            if(vm.datajson.length == 1){
                                setTimeout(() => {
                                    vm.openEdit()
                                    vm.getdlist(data.code, '', '');
                                }, 500);
                            }
                        }
                        vm.loading = false;
                    });
                    vm.$store.commit('clearSharedParams')
                }
                else if(form.name=='ecnsubsetparts' && Object.keys(vm.$store.state.sharedParams).length > 0){
                    const quer = {...vm.$store.state.sharedParams};
                    let code = quer.ecn_no
                    let arr = []
                    arr.push({
                        query_Condition: code,
                        query_field_name: "ECN_No",
                        query_field_type: "txt",
                        query_sort: "",
                        row_sign: 0
                    })
                    let parm = {
                        PageIndex: vm.PageIndex,
                        PageSize: vm.PageSize,
                        SelectIndex: vm.SelectIndex,
                        Param: arr
                    };
                    vm.$http.urlpost('/Eng/ECN/ECNList', parm, function (res) {
                        if (res.Success == 1) {
                            vm.datajson = res.DataContent;
                            vm.total = res.Totals;
                            vm.DbTbNames = res.DbTbNames;
                            /*if(vm.datajson.length == 1){
                                setTimeout(() => {
                                    vm.openEdit()
                                    vm.getdlist(code, '', '');
                                }, 500);
                            }*/
                            vm.$store.commit('clearSharedParams')
                        }
                        vm.loading = false;
                    });
                }
            });
        },
        create() {
            console.log('create');

        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.getecnno();
            that.GetALlECNType();
            that.getstagelist();
            that.getecnitem();
            that.getecndep();
            if(that.userData.Login_DB.toLowerCase() !="my"){ 
                that.getecnper();
            }
        },
        mounted() {
            let that = this;
            that.colsort();
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            let parm = {
                Code: that.userData.EmpCode
            }
            if(that.userData.Login_DB.toLowerCase() =="my"){ 
                that.IsLoginDB_MY="my";
            }
            let token = that.userData.token;
            that.Login_Group=that.userData.Login_Group;
            that.Login_DB=that.userData.Login_DB
            that.fileurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;            
            that.$http.urlpost('/Eng/ECN/GetEmpByCode', parm, function (res) {
                if (res.Success == 1) {
                    that.SuperiorName = res.DataContent.Head.SuperiorName
                }
            });
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.authority();
            //that.intidata();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
            that.setplanuser=Array.methods.getSysConfig('A121');
        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ECNViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            // 弹框设置
            // 客户
            showsal() {
                this.$refs.setsal.clearInput(true);
            },
            //头部物料弹框
            showitem() {
                this.$refs.setitem.clearInput(true);
            },
            showitems(ind) {
                console.log(ind);
                this.rowindx = ind.$index;
                this.$refs.setitems.clearInput(true);
            },
            //头接受人
            showgetpe(i) {
                this.rowindx = i;
                this.$refs.setper.clearInput(true);
            },
            //ecn实施计划负责人
            showgetpes(row) {
                this.rowindx = row.$index;
                this.$refs.setpers.clearInput(true);
            },
            showgetpess(ind) {
                this.rowindx = ind;
                this.$refs.setperss.clearInput(true);
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if(this.$route.name == this.$options.name){
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            check(datap) {
                let that = this
                console.log(JSON.stringify(datap))
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                console.log('arr' + arr)
                let arrlist = []
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 2) {
                        arrlist = [...arrlist, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[1],
                            exclusively_id: '',
                        }]
                    } else {
                        that.dataSetMaterials = [...that.dataSetMaterials, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[2],
                            exclusively_id: '',
                        }]
                    }
                }
                if (arrlist.length > 0) {
                    let parm = {
                        list: arrlist
                    }
                    that.$http.urlpost('/Eng/ECN/GetEcnPartInfoPasteByPartCode', parm, function (res) {
                        if (res.Success == 1) {                            
                            let arr = res.DataContent.List.filter(item => {
                                return that.PartLists.every(item2 => {
                                    return item.part_code != item2.part_code;
                                });
                            });
                            let data =arr;
                            for (let i = 0; i < data.length; i++) {
                                that.PartLists = [...that.PartLists, {
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version
                                    // exclusively_id: data[i].exclusively_id
                                }]
                            }
                        }
                    });
                }
            },
            /* 获取客户信息
            customer_id: "CSM"
            customer_name: "上海锐柯"
            index: 6
            shortname: "锐柯" */
            getsal(val) {
                let that=this;
                that.ecnno1 = val.customer_id;
                that.ECNMaster.Client_Name = val.customer_name;
                if(that.userData.Login_DB.toLowerCase() =="my"){ 
                    that.ECNMaster.Planner=that.user + '(' + that.userData.EmpCode + ')';
                    that.ECNMaster.Audit_Person=that.user + '(' + that.userData.EmpCode + ')';
                    that.ECNMaster.Create_Person=that.user + '(' + that.userData.EmpCode + ')';
                    that.ECNMaster.Confirm_Person=that.user + '(' + that.userData.EmpCode + ')';

                    that.$http.urlpost('Eng/ECN/GetEcnPartInfo', null, function (res) {
                        if (res.Success == 1) {
                            that.ECNMaster.Part_Code = res.DataContent.part_code;
                            that.ECNMaster.Part_Name = res.DataContent.part_name;
                            that.ECNMaster.Part_Version = res.DataContent.part_version;
                            // console.log("测试222")
                            that.proyx[6].Plate_Part_Code = res.DataContent.part_code;
                            that.proyx[6].Plate_Part_Version = res.DataContent.part_version;
                            that.proyx[7].Plate_Part_Code = res.DataContent.part_code;
                            that.proyx[7].Plate_Part_Version = res.DataContent.part_version;
                            // console.log("测试333")
                            that.proyx[6].Plate_Stock_Num=0;                        
                            that.proyx[7].Plate_Stock_Num=0;
                        }
                    });
                }
            },
            
            handleChange(file, fileList) {
                this.FileList = fileList.slice(-3);
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(res.Msg);
                } else {
                    that.$message.success(res.Msg);
                    that.loadfiles(that.fileparm)
                }
            },
            lookfiles(val) {
                window.open(val.row.path,"_blank");
            },
            filedel(val){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if(val.row.exclusively_id == 0){
                            that.FileLists.splice(val.$index, 1)
                        } else {
                            let parm = {
                                ids: val.row.exclusively_id,
                                FilesSrc: val.row.path
                            }
                            that.$http.urlpost('/Basic/ECN/DelItemFileByID', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.loadfiles(that.fileparm);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 上传
            files(val) {
                let that = this;
                //初始化保存附件参数                
                that.FileLists = [];
                that.fileparm.Relation_ECN_No = val.row.Relation_ECN_No;
                that.fileparm.Relation_Strategy_No = val.row.Relation_Strategy_No;
                
                // that.FileList.forEach(item => {
                //     if (item.Code == val.row.Relation_ECN_No) {
                //         that.FileLists.push(item);
                //     }
                // })
                const key = generatekey(8); // 也可直接指定key let key = 'des';                
                that.fileparm.Login_Group=encryptDes(that.Login_Group,key);
                that.fileparm.Login_DB=encryptDes(that.Login_DB,key);
                that.loadfiles(that.fileparm);
               
            },
            loadfiles(val){
                let that = this;
                //初始化保存附件参数                
                that.FileLists = [];
                 //  查询数据
                 let parm = {
                    Relation_ECN_No: val.Relation_ECN_No,
                    Relation_Strategy_No:val.Relation_Strategy_No,
                    LangType:  that.$processdata.getLang(),
                }
                that.$http.urlpost('/Basic/ECN/GetEcnFilesLists', parm, function (res) {
                    if (res.Success == 1) {
                        that.FileLists=res.DataContent.FileList;
                    }
                });
                this.isVisiblefile = true;
            },
            /* 获取物料信息
            part_code: "00000001-1"
            part_name: "ghtyty"
            part_version: "A" */
            getitem(val) {
                console.log(val);
                this.ECNMaster.Part_Code = val.part_code;
                this.ECNMaster.Part_Name = val.part_name;
                this.ECNMaster.Part_Version = val.part_version;
                this.proyx[6].Plate_Part_Code = val.part_code;
                this.proyx[6].Plate_Part_Version = val.part_version;
                this.proyx[7].Plate_Part_Code = val.part_code;
                this.proyx[7].Plate_Part_Version = val.part_version;
                this.gersum(6, val.part_code, val.part_version, 2);
                this.gersum(7, val.part_code, val.part_version, 1);
            },
            getitems(val) {
                this.proyx[this.rowindx].Plate_Part_Code = val.part_code;
                this.proyx[this.rowindx].Plate_Part_Version = val.part_version;
                this.gersum(this.rowindx, val.part_code, val.part_version, 0);
            },
            /* 获取接受人
            code: "01001"
            dept: "董事长"
            index: 7
            name: "张新联" */
            getper(val) {
                if (this.rowindx == 0) {
                    this.ECNMaster.ECN_Accept_Person = val.name + '(' + val.code + ')';
                }
                if (this.rowindx == 1) {
                    this.ECNMaster.Planner = val.name + '(' + val.code + ')';
                }
                if (this.rowindx == 2) {
                    this.ECNMaster.ECN_Produce_Person = val.name + '(' + val.code + ')';
                }
                if (this.rowindx == 3) {
                    this.ECNMaster.ECN_Purchase_Person = val.name + '(' + val.code + ')';
                }
                this.$forceUpdate();
            },
            getpers(val) {
                //console.log(val);
                this.ECNDetail[this.rowindx].Plan_Person = val.name + '(' + val.code + ')';
                this.ECNDetail[this.rowindx].checked = true;
                this.$set(this.ECNDetail, this.rowindx, this.ECNDetail[this.rowindx]);
            },
            checkf(e, val) {
                let that = this;
                let ind = val.$index;
                if(that.setplanuser==1){
                    if(this.ECNDetail[ind].checked==true){
                        if (!e) {
                            that.ECNDetail[ind].Plan_Person = null;
                            that.ECNDetail[ind].Plan_Time = null;
                            that.ECNDetail[ind].Complete_Time = null;
                            that.ECNDetail[ind].ismustfile = 0;
                        }
                        let parm = {
                            part_code: that.ECNMaster.Part_Code,
                            part_version: that.ECNMaster.Part_Version,
                            strategy_no: that.ECNDetail[ind].Relation_Strategy_No
                        };
                        that.$http.urlpost('Eng/ECN/GetProjectUser', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                console.log(res);
                                that.ECNDetail[ind].Plan_Person = res.UniqueNum;
                                that.$set(that.ECNDetail, ind, that.ECNDetail[ind]);
                                that.$forceUpdate();
                            }
                        });    
                    } 
                    else{
                        if (!e) {
                            that.ECNDetail[ind].Plan_Person = null;
                            that.ECNDetail[ind].Plan_Time = null;
                            that.ECNDetail[ind].Complete_Time = null;
                            that.ECNDetail[ind].ismustfile = 0;                        
                        }
                        that.$set(that.ECNDetail, ind, that.ECNDetail[ind]);
                        that.$forceUpdate();
                    }
                }
                else{
                    if (!e) {
                        that.ECNDetail[ind].Plan_Person = null;
                        that.ECNDetail[ind].Plan_Time = null;
                        that.ECNDetail[ind].Complete_Time = null;
                        that.ECNDetail[ind].ismustfile = 0;                        
                    }
                    that.$set(that.ECNDetail, ind, that.ECNDetail[ind]);
                    that.$forceUpdate(); 
                }           

                
            },
            checismustfile(e,val){                             
                let ind = val.$index;
                if (e){
                    if (this.$limits.fnIsEmpty(val.row.Plan_Person)){
                        this.ECNDetail[ind].ismustfile = 0;
                    }
                }
                this.$set(this.ECNDetail, ind, this.ECNDetail[ind]);
                this.$forceUpdate();
            },
            copyplandate(){
                //拷贝计划日期
                let that = this
                let Plan_Time;
                if(that.ECNDetail.length>0){
                    for(let i = 0;i<that.ECNDetail.length;i++){
                        if(!that.$limits.fnIsEmpty(that.ECNDetail[i].Plan_Time) && that.ECNDetail[i].checked == true){
                            Plan_Time=that.ECNDetail[i].Plan_Time;
                            break;
                        }
                    }
                    for(let i = 0;i<that.ECNDetail.length;i++){
                        if(that.$limits.fnIsEmpty(that.ECNDetail[i].Plan_Time) && that.ECNDetail[i].checked == true){
                             that.ECNDetail[i].Plan_Time=Plan_Time;
                        }
                    }
                    
                } else {
                    that.$message.warning(that.$t('getapi[9036]'))
                }
            },
            checkfclick(val) {
                console.log(val);
                let ind = val.$index;
                this.ECNDetail[ind].checked = true;
                this.$set(this.ECNDetail, ind, this.ECNDetail[ind]);
                this.$forceUpdate();
            },
            getperss(val) {
                this.ecndep[this.rowindx].remark = val.name + '(' + val.code + ')';
                this.ecndep[this.rowindx].checked = true;
                this.$forceUpdate();
            },
            gersum(ind, code, ver, typ) {
                let that = this;
                let parm = {
                    Part_Code: code,
                    Part_Version: ver,
                    workProc: typ
                };
                that.$http.urlpost('Eng/ECN/GetSumOnHand', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.proyx[ind].Plate_Stock_Num = that.sums(res.DataContent);
                        that.$forceUpdate();
                    }
                });
            },
            sums(nums) {
                if (typeof nums == 'number') {
                    // 判断是否为数字类型   数字类型自动  舍0
                    nums = nums.toString(); // 先转成  字符串类型
                    if (nums.indexOf('.') != -1) {
                        // 判断 有无小数点  0 表示 有小数点  -1  表示没有小数点
                        let b = nums.split('.'); // 根据小数点  转换字符串为数组
                        if (b[1].length == 1) {
                            // 判断 有几位小数  如果有一位  加一个0
                            b = b.join('.');
                            b += '0';
                            nums = b;
                        }
                    } else {
                        nums += '.00';
                    }
                } else if (typeof nums == 'string') {
                    // 同理
                    if (nums.indexOf('.') != -1) {
                        let b = nums.split('.');
                        if (b[1].length == 1) {
                            b = b.join('.');
                            b += '0';
                            nums = b;
                        }
                    } else {
                        nums += '.00';
                    }
                }
                return nums;
            },
            //ECNNO下拉选项
            getecnno() {
                let that = this;
                that.$http.urlpost('/Eng/ECN/GetECNNO', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecnnolist = res.DataContent;
                        that.ecnno = res.DataContent[0].items;
                    }
                });
            },
            //ECN类型下拉选项
            GetALlECNType() {
                let that = this;
                that.$http.urlpost('/Eng/ECN/GetALlECNType', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecntypelist = res.DataContent;
                    }
                });
            },
            //当前阶段下拉选项
            getstagelist() {
                let that = this;
                that.$http.urlpost('Eng/ECN/GetALlECNProductStage', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecnstagelist = res.DataContent;
                    }
                });
            },
            //获取实施条目
            getecnitem() {
                let that = this;
                that.$http.urlpost('/Basic/ECN/GetECNStrategyList', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecnitem = res.DataContent;
                        that.ECNDetail = res.DataContent;
                        that.ECNDetail.forEach(item => {
                            item.checked = false;
                            item.Relation_Strategy_No = item.Strategy_No;
                            item.Plan_Person = null;
                            item.Plan_Time = null;
                            item.Complete_Time = null;
                            item.Relation_ECN_No = null;
                            item.ismustfile = 0;
                        });
                    }
                });
            },
            //获取分发部门
            getecndep() {
                let that = this;
                that.$http.urlpost('/Basic/ECN/GetECNDepartmentList', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecndep = res.DataContent;
                        that.ecndep.forEach(item => {
                            item.checked = false;
                            item.remark = '';
                        });
                    }
                });
            },
            //获取会签人员
            getecnper() {
                let that = this;
                that.$http.urlpost('/Basic/ECN/GetECNSignatureStrategyList', {}, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.ecnper = res.DataContent;
                        that.ecnper.forEach(item => {
                            item.Opinion = null;
                            item.superior_flag = 0;
                            item.Opinion_Person = item.User_Name;
                            item.Opinion_Time = null;
                            item.Relation_ECN_No = null;
                            item.Relation_Signature_Strategy_No = item.Signature_Strategy_No;
                            item.opinion_status = '-1';
                            item.role_name = item.Role_Name;
                            item.user_name = item.User_Name;
                        });
                    }
                });
            },
            //分发部门
            ecndeps() {
                this.$forceUpdate();
            },
            //强制关闭
            closeqz() {
                let that = this;
                that.$XModal.confirm(that.$t('getapi[8725]')).then(type => {//确认强制关闭？
                    if (type == 'confirm') {
                        let parm = that.ECNMaster;
                        parm.ECN_No = that.ecnno + '-ECN-' + that.ecnno1 + '-' + that.ecnno2;
                        parm.ECN_Accept_Time = parm.ECN_Accept_Time != '' ? parm.ECN_Accept_Time : null;
                        parm.Client_Accept_Time = parm.Client_Accept_Time != '' ? parm.Client_Accept_Time : null;
                        parm.Create_Time = parm.Create_Time != '' ? parm.Create_Time : null;
                        parm.Audit_Time = parm.Audit_Time != '' ? parm.Audit_Time : null;
                        parm.Confirm_Time = parm.Confirm_Time != '' ? parm.Confirm_Time : null;
                        parm.ECN_Produce_Time = parm.ECN_Produce_Time != '' ? parm.ECN_Produce_Time : null;
                        parm.ECN_Purchase_Time = parm.ECN_Purchase_Time != '' ? parm.ECN_Purchase_Time : null;
                        parm.ECN_Close_Time = parm.ECN_Close_Time != '' ? parm.ECN_Close_Time : null;
                        parm.Modify_Time = parm.Modify_Time != '' ? parm.Modify_Time : null;
                        console.log(JSON.stringify(parm));
                        that.loading = true;
                        that.$http.urlpost('/Eng/ECN/CloseECN', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[4230]'));//关闭成功
                                that.intidata();
                                that.getdlist(parm.ECN_No, '', '');
                            }
                        });
                    }
                });
            },
            //会签弹框
            hq(e) {
                this.sign = e.row;
                this.dialogVisible = true;
            },
            async hqbtn(i) {
                let that = this;
                if (that.hqbtnLoading) return;
                that.hqbtnLoading = true;
                const complete = () => {
                    setTimeout(() => {
                        that.hqbtnLoading = false;
                    }, 3000);
                };
                let parm = {
                    Relation_ECN_No: that.sign.Relation_ECN_No,
                    Relation_Signature_Strategy_No: that.sign.Relation_Signature_Strategy_No,
                    Opinion_Person: that.sign.Opinion_Person,
                    Opinion: that.sign.Opinion,
                    Opinion_Time: that.getnewdate(),
                    Role_name: that.sign.role_name,
                    User_name: that.sign.user_name,
                    Opinion_status: that.sign.opinion_status
                };
                if (that.sign.Opinion) {
                    if (i == 0) {
                        parm.Opinion_status = 1;
                        that.$http.urlpost('Eng/ECN/btnSignOKClick', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[8726]'));
                                that.intidata();
                                that.getdlist(that.ECNMaster.ECN_No, '', '');
                                that.dialogVisible = false;
                            }
                            complete();
                        });
                    } else {
                        parm.Opinion_status = 0;
                        that.$http.urlpost('Eng/ECN/btnSignNoClick', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[8726]'));
                                that.intidata();
                                that.getdlist(that.ECNMaster.ECN_No, '', '');
                                that.dialogVisible = false;
                            }
                            complete();
                        });
                    }
                } else {
                    that.$message.error(that.$t('getapi[8727]'));
                    complete();
                }
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6125]"),this.$t("getapi[18]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.btn.colse = false;
                if (that.$limits.authority('plv4', 344, 1) == 1) {
                    that.btn.colse = true
                } else {
                    that.btn.colse = false
                }

                //管理界面
                if (that.$limits.authority('plv2', 37, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 37, 1) == 2) {
                    if (that.$limits.authority('plv3', 37, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 37, 1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.ECNMaster.ECN_No)) {
                            if (that.ECNMaster.ECN_Status == '0' || that.ECNMaster.ECN_Status == '1' || that.ECNMaster.ECN_Status == '2') {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 37, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.ECNMaster.ECN_No)) {
                            if (that.ECNMaster.ECN_Status == '0') {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,del');
                            } else if(that.ECNMaster.ECN_Status == '1' || that.ECNMaster.ECN_Status == '2'){
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                }
                else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    if (that.$limits.authority('plv2', 37, 1) > 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }

                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.rowdel = false;
                that.btn.delsign= false;
                if(that.ECNMaster.ECN_Status==0){
                    that.btn.delsign=true;
                }
                that.btn.delpart= false;
                if(that.ECNMaster.ECN_Status==0){
                    that.btn.delpart=true;
                }
                
                if (that.selectIDData.length > 0) {
                    if (that.ECNMaster.ECN_Status == '0') {
                        that.btn.rowdel = true;
                    }
                }
                that.btn.implement = false
                if (that.$limits.authority('plv4', 344, 1) > 0) {
                    that.btn.implement = true
                }
                if (that.userData.username == that.SuperiorName) {
                    that.btn.implement = true
                }
            },
            //表格背景
            tableRowClassName({row, rowIndex}) {
                //console.log(row.enable_flag);
                if (row.enable_flag == '是') {
                    return 'warning-row';
                }
                if (row.ECN_Status == '不可用') {
                    return 'dark-row';
                }
            },
            tableRowClassNameRight({row, rowIndex}) {
                row.index = rowIndex;
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.PageIndex = 1;
                this.intidata();
            },

            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('ecnlist',val)
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
            },

            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                console.log(parm);
                that.$http.urlpost('/Eng/ECN/ECNList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                    that.loading = false;
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                });
            },
            //获取详细
            getdlist(id, name, where) {
                let that = this;
                let parm = {
                    Code: id
                };
                that.Type = 0;
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Eng/ECN/ECNInfo', parm, function (res) {
                    loadingInstance.close()
                    if (res.Success == 1) {
                        that.IsEdit = 0;
                        that.formInline = res.DataContent;
                        that.ECNMaster = res.DataContent.ECNMaster;
                        that.ECNDetail = res.DataContent.ECNDetail;
                        that.PartLists = res.DataContent.PartLists;
                        
                        that.ECNDetail.forEach(item => {
                            if (item.Plan_Person) {
                                item.checked = true;
                            } else {
                                item.checked = false;
                            }
                        });
                        that.ECNSignature = res.DataContent.ECNSignature;
                        let reg = /^(\w+)[-ECN-]{5}(.*)[-]{1}(\d+)$/
                        let enid = reg.exec(res.DataContent.ECNMaster.ECN_No)
                        console.log('测试' + JSON.stringify(enid))
                        that.ecnno = enid[1];
                        that.ecnno1 = enid[2];
                        that.ecnno2 = enid[3];
                        let Department = res.DataContent.ECNMaster.Department.split('|');
                        that.ecndep.forEach(item => {
                            item.checked = false;
                            item.remark = '';
                            Department.forEach(items => {
                                let itms = items.split('{');
                                if (item.Department_Name == itms[0]) {
                                    item.checked = true;
                                    item.remark = itms[1].replace('}', '');
                                }
                            });
                        });
                        // ECN会签
                        that.ecnper = res.DataContent.ECNSignature;
                        that.ecnper.forEach(item => {
                            if (item.opinion_status == '未会签') {
                                item.opinion_status = -1;
                            }
                            if (item.opinion_status == '不同意') {
                                item.opinion_status = 0;
                            }
                            if (item.opinion_status == '同意') {
                                item.opinion_status = 1;
                            }
                        });
                        console.log(that.ecnper);
                        //产品影响
                        that.proyx[0].Plate_Part_Code = res.DataContent.ECNMaster.Plate_Part_Code_1;
                        that.proyx[0].Plate_Part_Version = res.DataContent.ECNMaster.Plate_Part_Version_1;
                        that.proyx[0].Plate_Onway_Num = res.DataContent.ECNMaster.Plate_Onway_Num_1;
                        that.proyx[0].Plate_Stock_Num = res.DataContent.ECNMaster.Plate_Stock_Num_1;
                        that.proyx[0].Plate_Deal_With = res.DataContent.ECNMaster.Plate_Deal_With_1;
                        that.proyx[0].Procurement_Deal_With = res.DataContent.ECNMaster.Plate_Deal_With_1_0;
                        that.proyx[0].Plate_Price = res.DataContent.ECNMaster.Plate_Price_1;
                        that.proyx[0].Plate_Mold_Cost = res.DataContent.ECNMaster.Plate_Mold_Cost_1;
                        that.proyx[0].Plate_Amount = res.DataContent.ECNMaster.Plate_Amount_1;
                        that.proyx[0].Plate_Bear = res.DataContent.ECNMaster.Plate_Bear_1;
                        that.proyx[1].Plate_Part_Code = res.DataContent.ECNMaster.Plate_Part_Code_2;
                        that.proyx[1].Plate_Part_Version = res.DataContent.ECNMaster.Plate_Part_Version_2;
                        that.proyx[1].Plate_Onway_Num = res.DataContent.ECNMaster.Plate_Onway_Num_2;
                        that.proyx[1].Plate_Stock_Num = res.DataContent.ECNMaster.Plate_Stock_Num_2;
                        that.proyx[1].Plate_Deal_With = res.DataContent.ECNMaster.Plate_Deal_With_2;
                        that.proyx[1].Procurement_Deal_With = res.DataContent.ECNMaster.Plate_Deal_With_2_0;
                        that.proyx[1].Plate_Price = res.DataContent.ECNMaster.Plate_Price_2;
                        that.proyx[1].Plate_Mold_Cost = res.DataContent.ECNMaster.Plate_Mold_Cost_2;
                        that.proyx[1].Plate_Amount = res.DataContent.ECNMaster.Plate_Amount_2;
                        that.proyx[1].Plate_Bear = res.DataContent.ECNMaster.Plate_Bear_2;
                        that.proyx[2].Plate_Part_Code = res.DataContent.ECNMaster.Plate_Part_Code_3;
                        that.proyx[2].Plate_Part_Version = res.DataContent.ECNMaster.Plate_Part_Version_3;
                        that.proyx[2].Plate_Onway_Num = res.DataContent.ECNMaster.Plate_Onway_Num_3;
                        that.proyx[2].Plate_Stock_Num = res.DataContent.ECNMaster.Plate_Stock_Num_3;
                        that.proyx[2].Plate_Deal_With = res.DataContent.ECNMaster.Plate_Deal_With_3;
                        that.proyx[2].Procurement_Deal_With = res.DataContent.ECNMaster.Plate_Deal_With_3_0;
                        that.proyx[2].Plate_Price = res.DataContent.ECNMaster.Plate_Price_3;
                        that.proyx[2].Plate_Mold_Cost = res.DataContent.ECNMaster.Plate_Mold_Cost_3;
                        that.proyx[2].Plate_Amount = res.DataContent.ECNMaster.Plate_Amount_3;
                        that.proyx[2].Plate_Bear = res.DataContent.ECNMaster.Plate_Bear_3;
                        that.proyx[3].Plate_Part_Code = res.DataContent.ECNMaster.Procurement_Part_Code_1;
                        that.proyx[3].Plate_Part_Version = res.DataContent.ECNMaster.Procurement_Part_Version_1;
                        that.proyx[3].Plate_Onway_Num = res.DataContent.ECNMaster.Procurement_Onway_Num_1;
                        that.proyx[3].Plate_Stock_Num = res.DataContent.ECNMaster.Procurement_Stock_Num_1;
                        that.proyx[3].Plate_Deal_With = res.DataContent.ECNMaster.Procurement_Deal_With_1;
                        that.proyx[3].Procurement_Deal_With = res.DataContent.ECNMaster.Procurement_Deal_With_1_0;
                        that.proyx[3].Plate_Price = res.DataContent.ECNMaster.Procurement_Price_1;
                        that.proyx[3].Plate_Mold_Cost = res.DataContent.ECNMaster.Procurement_Mold_Cost_1;
                        that.proyx[3].Plate_Amount = res.DataContent.ECNMaster.Procurement_Amount_1;
                        that.proyx[3].Plate_Bear = res.DataContent.ECNMaster.Procurement_Bear_1;
                        that.proyx[4].Plate_Part_Code = res.DataContent.ECNMaster.Procurement_Part_Code_2;
                        that.proyx[4].Plate_Part_Version = res.DataContent.ECNMaster.Procurement_Part_Version_2;
                        that.proyx[4].Plate_Onway_Num = res.DataContent.ECNMaster.Procurement_Onway_Num_2;
                        that.proyx[4].Plate_Stock_Num = res.DataContent.ECNMaster.Procurement_Stock_Num_2;
                        that.proyx[4].Plate_Deal_With = res.DataContent.ECNMaster.Procurement_Deal_With_2;
                        that.proyx[4].Procurement_Deal_With = res.DataContent.ECNMaster.Procurement_Deal_With_2_0;
                        that.proyx[4].Plate_Price = res.DataContent.ECNMaster.Procurement_Price_2;
                        that.proyx[4].Plate_Mold_Cost = res.DataContent.ECNMaster.Procurement_Mold_Cost_2;
                        that.proyx[4].Plate_Amount = res.DataContent.ECNMaster.Procurement_Amount_2;
                        that.proyx[4].Plate_Bear = res.DataContent.ECNMaster.Procurement_Bear_2;
                        that.proyx[5].Plate_Part_Code = res.DataContent.ECNMaster.Procurement_Part_Code_3;
                        that.proyx[5].Plate_Part_Version = res.DataContent.ECNMaster.Procurement_Part_Version_3;
                        that.proyx[5].Plate_Onway_Num = res.DataContent.ECNMaster.Procurement_Onway_Num_3;
                        that.proyx[5].Plate_Stock_Num = res.DataContent.ECNMaster.Procurement_Stock_Num_3;
                        that.proyx[5].Plate_Deal_With = res.DataContent.ECNMaster.Procurement_Deal_With_3;
                        that.proyx[5].Procurement_Deal_With = res.DataContent.ECNMaster.Procurement_Deal_With_3_0;
                        that.proyx[5].Plate_Price = res.DataContent.ECNMaster.Procurement_Price_3;
                        that.proyx[5].Plate_Mold_Cost = res.DataContent.ECNMaster.Procurement_Mold_Cost_3;
                        that.proyx[5].Plate_Amount = res.DataContent.ECNMaster.Procurement_Amount_3;
                        that.proyx[5].Plate_Bear = res.DataContent.ECNMaster.Procurement_Bear_3;
                        that.proyx[6].Plate_Part_Code = res.DataContent.ECNMaster.Part_Code;
                        that.proyx[6].Plate_Part_Version = res.DataContent.ECNMaster.Part_Version;
                        that.proyx[6].Plate_Onway_Num = res.DataContent.ECNMaster.Making_Onway_Num;
                        that.proyx[6].Plate_Stock_Num = res.DataContent.ECNMaster.Making_Stock_Num;
                        that.proyx[6].Plate_Deal_With = res.DataContent.ECNMaster.Making_Deal_With;
                        that.proyx[6].Procurement_Deal_With = res.DataContent.ECNMaster.Making_Deal_With_0;
                        that.proyx[6].Plate_Price = res.DataContent.ECNMaster.Making_Price;
                        that.proyx[6].Plate_Mold_Cost = res.DataContent.ECNMaster.Making_Mold_Cost;
                        that.proyx[6].Plate_Amount = res.DataContent.ECNMaster.Making_Amount;
                        that.proyx[6].Plate_Bear = res.DataContent.ECNMaster.Making_Bear;
                        that.proyx[7].Plate_Part_Code = res.DataContent.ECNMaster.Part_Code;
                        that.proyx[7].Plate_Part_Version = res.DataContent.ECNMaster.Part_Version;
                        that.proyx[7].Plate_Onway_Num = res.DataContent.ECNMaster.Product_Onway_Num;
                        that.proyx[7].Plate_Stock_Num = res.DataContent.ECNMaster.Product_Stock_Num;
                        that.proyx[7].Plate_Deal_With = res.DataContent.ECNMaster.Product_Deal_With;
                        that.proyx[7].Procurement_Deal_With = res.DataContent.ECNMaster.Product_Deal_With_0;
                        that.proyx[7].Plate_Price = res.DataContent.ECNMaster.Product_Price;
                        that.proyx[7].Plate_Mold_Cost = res.DataContent.ECNMaster.Product_Mold_Cost;
                        that.proyx[7].Plate_Amount = res.DataContent.ECNMaster.Product_Amount;
                        that.proyx[7].Plate_Bear = res.DataContent.ECNMaster.Product_Bear;
                    }
                    that.authority();
                    that.Plate_Mold_Costs = 0;
                    that.Plate_Amounts = 0;
                    that.proyx.forEach(item => {
                        if (item.Plate_Mold_Cost) {
                            that.Plate_Mold_Costs = parseFloat(that.Plate_Mold_Costs) + parseFloat(item.Plate_Mold_Cost);
                        }
                        if (item.Plate_Amount) {
                            that.Plate_Amounts = parseFloat(that.Plate_Amounts) + parseFloat(item.Plate_Amount);
                        }
                    });
                });

            },
            onEditorChange(val){
                let that = this
                that.ECNMaster.ECN_Description = val
            },
            //已完成
            endbtn(row) {
                let that = this;
                that.loading = true;
                let parm = {
                    Relation_ECN_No: row.row.Relation_ECN_No,
                    Relation_Strategy_No: row.row.Relation_Strategy_No,
                    Plan_Person: row.row.Plan_Person,
                    Plan_Time: row.row.Plan_Time,
                    Complete_Time: that.getnewdate(),
                    ismustfile:row.row.ismustfile
                };
                console.log(parm);
                that.$http.urlpost('/Eng/ECN/CompleteItemClick', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[6157]'));//'已完成'
                        that.intidata();
                        that.getdlist(that.ECNMaster.ECN_No, '', '');
                    }
                    that.loading = false;
                });
            },
            // 驳回
            reject(type){
                let that = this
                if(type == 1){
                    that.RejectStr1 = ''
                } else {
                    that.RejectStr2 = ''
                }
                that.RejectType = type
                that.isShowDialog = true
            },
            confirmReject(type){
                let that = this
                let parm = that.ECNMaster
                if(type == 1){
                    parm.RejectStr1 = that.RejectStr1
                    parm.RejectStr2 = ''
                } else if(type == 2){
                    parm.RejectStr1 = ''
                    parm.RejectStr2 = that.RejectStr2
                }
                that.loading = true;
                that.$http.urlpost('/Eng/ECN/RejectS0', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata();
                        that.getdlist(that.ECNMaster.ECN_No, '', '');
                        that.isShowDialog = false;
                    } else {
                        that.getdlist(that.ECNMaster.ECN_No, '', '');
                    }
                    that.loading = false;
                });
            },
            //操作状态保存
            savas(sta) {
                let that = this
                this.$XModal.confirm(that.$t('getapi[8596]')).then(type => {//'确定要执行嘛'
                    if (type == 'confirm') {
                        console.log(sta);
                        switch (sta) {
                            case 1:
                                this.ECNMaster.Create_Time = this.getnewdate();
                                break;
                            case 2:
                                this.ECNMaster.Planner_Affirm = this.getnewdate();
                                break;
                            case 3:
                                this.ECNMaster.Audit_Time = this.getnewdate();
                                break;
                            case 4:
                                this.ECNMaster.Confirm_Time = this.getnewdate();
                                break;
                            case 8:
                                this.ECNMaster.ECN_Produce_Time = this.getnewdate();
                                break;
                            case 9:
                                this.ECNMaster.ECN_Purchase_Time = this.getnewdate();
                                break;
                        }
                        this.Type = sta;
                        this.IsEdit = 0;
                        if (sta < 8) {
                            this.ECNMaster.ECN_Status = sta;
                        }
                        this.sava();
                    }
                });
            },
            // 保存数据
            async sava() {
                let that = this;
                if (that.savasLoading) return;
                that.savasLoading = true;
                try {
                    if(that.ecnno1 == ''){
                        that.$message.warning(that.$t('getapi[9879]'))//'客户不能为空'
                        return false
                    }
                    if(that.ECNMaster.Audit_Person == ''){
                        that.$message.warning(that.$t('getapi[8728]'))//'审核人不能为空'
                        return false
                    }
                    if(that.ECNMaster.Confirm_Person == ''){
                        that.$message.warning(that.$t('getapi[8729]'))//'批准人不能为空'
                        return false
                    }
                    for(let i = 0;i<that.ECNDetail.length;i++){
                        if(that.ECNDetail[i].checked == true && that.ECNDetail[i].Content == '压力机模、冲模、工装确认' && that.$limits.fnIsEmpty(that.ECNDetail[i].Plan_Person)){
                            that.$message.warning('ECN实施，当实施内容为压力机模、冲模、工装确认,必须选择负责人')
                            return false
                        }
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    let loadingInstance = Loading.service(Common.maskoption1);
                    let parm = {
                        Type: that.Type,
                        IsEdit: that.IsEdit,
                        ECNSignature: that.ecnper,
                        ECNDetail: that.ECNDetail,
                        ECNMaster: that.ECNMaster,
                        PartLists:that.PartLists,
                    };
                    parm.ECNMaster.Department = ''
                    that.ecndep.forEach(item => {
                        if (item.checked) {
                            parm.ECNMaster.Department += item.Department_Name + '{' + item.remark + '}|';
                        }
                    });
                    parm.ECNMaster.ECN_No = that.ecnno + '-ECN-' + that.ecnno1 + '-' + that.ecnno2;
                    parm.ECNMaster.ECN_Accept_Time = parm.ECNMaster.ECN_Accept_Time != '' ? parm.ECNMaster.ECN_Accept_Time : null;
                    parm.ECNMaster.Client_Accept_Time = parm.ECNMaster.Client_Accept_Time != '' ? parm.ECNMaster.Client_Accept_Time : null;
                    parm.ECNMaster.Create_Time = parm.ECNMaster.Create_Time != '' ? parm.ECNMaster.Create_Time : null;
                    parm.ECNMaster.Audit_Time = parm.ECNMaster.Audit_Time != '' ? parm.ECNMaster.Audit_Time : null;
                    parm.ECNMaster.Confirm_Time = parm.ECNMaster.Confirm_Time != '' ? parm.ECNMaster.Confirm_Time : null;
                    parm.ECNMaster.ECN_Produce_Time = parm.ECNMaster.ECN_Produce_Time != '' ? parm.ECNMaster.ECN_Produce_Time : null;
                    parm.ECNMaster.ECN_Purchase_Time = parm.ECNMaster.ECN_Purchase_Time != '' ? parm.ECNMaster.ECN_Purchase_Time : null;
                    parm.ECNMaster.ECN_Close_Time = parm.ECNMaster.ECN_Close_Time != '' ? parm.ECNMaster.ECN_Close_Time : null;
                    parm.ECNMaster.Modify_Time = parm.ECNMaster.Modify_Time != '' ? parm.ECNMaster.Modify_Time : null;
                    //产品影响
                    parm.ECNMaster.Plate_Part_Code_1 = that.proyx[0].Plate_Part_Code;
                    parm.ECNMaster.Plate_Part_Version_1 = that.proyx[0].Plate_Part_Version;
                    parm.ECNMaster.Plate_Onway_Num_1 = that.proyx[0].Plate_Onway_Num;
                    parm.ECNMaster.Plate_Stock_Num_1 = that.proyx[0].Plate_Stock_Num;
                    parm.ECNMaster.Plate_Deal_With_1 = that.proyx[0].Plate_Deal_With;
                    parm.ECNMaster.Plate_Deal_With_1_0 = that.proyx[0].Procurement_Deal_With;
                    parm.ECNMaster.Plate_Price_1 = that.proyx[0].Plate_Price;
                    parm.ECNMaster.Plate_Mold_Cost_1 = that.proyx[0].Plate_Mold_Cost;
                    parm.ECNMaster.Plate_Amount_1 = that.proyx[0].Plate_Amount;
                    parm.ECNMaster.Plate_Bear_1 = that.proyx[0].Plate_Bear;
                    parm.ECNMaster.Plate_Part_Code_2 = that.proyx[1].Plate_Part_Code;
                    parm.ECNMaster.Plate_Part_Version_2 = that.proyx[1].Plate_Part_Version;
                    parm.ECNMaster.Plate_Onway_Num_2 = that.proyx[1].Plate_Onway_Num;
                    parm.ECNMaster.Plate_Stock_Num_2 = that.proyx[1].Plate_Stock_Num;
                    parm.ECNMaster.Plate_Deal_With_2 = that.proyx[1].Plate_Deal_With;
                    parm.ECNMaster.Plate_Deal_With_2_0 = that.proyx[1].Procurement_Deal_With;
                    parm.ECNMaster.Plate_Price_2 = that.proyx[1].Plate_Price;
                    parm.ECNMaster.Plate_Mold_Cost_2 = that.proyx[1].Plate_Mold_Cost;
                    parm.ECNMaster.Plate_Amount_2 = that.proyx[1].Plate_Amount;
                    parm.ECNMaster.Plate_Bear_2 = that.proyx[1].Plate_Bear;
                    parm.ECNMaster.Plate_Part_Code_3 = that.proyx[2].Plate_Part_Code;
                    parm.ECNMaster.Plate_Part_Version_3 = that.proyx[2].Plate_Part_Version;
                    parm.ECNMaster.Plate_Onway_Num_3 = that.proyx[2].Plate_Onway_Num;
                    parm.ECNMaster.Plate_Stock_Num_3 = that.proyx[2].Plate_Stock_Num;
                    parm.ECNMaster.Plate_Deal_With_3 = that.proyx[2].Plate_Deal_With;
                    parm.ECNMaster.Plate_Deal_With_3_0 = that.proyx[2].Procurement_Deal_With;
                    parm.ECNMaster.Plate_Price_3 = that.proyx[2].Plate_Price;
                    parm.ECNMaster.Plate_Mold_Cost_3 = that.proyx[2].Plate_Mold_Cost;
                    parm.ECNMaster.Plate_Amount_3 = that.proyx[2].Plate_Amount;
                    parm.ECNMaster.Plate_Bear_3 = that.proyx[2].Plate_Bear;
                    parm.ECNMaster.Procurement_Part_Code_1 = that.proyx[3].Plate_Part_Code;
                    parm.ECNMaster.Procurement_Part_Version_1 = that.proyx[3].Plate_Part_Version;
                    parm.ECNMaster.Procurement_Onway_Num_1 = that.proyx[3].Plate_Onway_Num;
                    parm.ECNMaster.Procurement_Stock_Num_1 = that.proyx[3].Plate_Stock_Num;
                    parm.ECNMaster.Procurement_Deal_With_1 = that.proyx[3].Plate_Deal_With;
                    parm.ECNMaster.Procurement_Deal_With_1_0 = that.proyx[3].Procurement_Deal_With;
                    parm.ECNMaster.Procurement_Price_1 = that.proyx[3].Plate_Price;
                    parm.ECNMaster.Procurement_Mold_Cost_1 = that.proyx[3].Plate_Mold_Cost;
                    parm.ECNMaster.Procurement_Amount_1 = that.proyx[3].Plate_Amount;
                    parm.ECNMaster.Procurement_Bear_1 = that.proyx[3].Plate_Bear;
                    parm.ECNMaster.Procurement_Part_Code_2 = that.proyx[4].Plate_Part_Code;
                    parm.ECNMaster.Procurement_Part_Version_2 = that.proyx[4].Plate_Part_Version;
                    parm.ECNMaster.Procurement_Onway_Num_2 = that.proyx[4].Plate_Onway_Num;
                    parm.ECNMaster.Procurement_Stock_Num_2 = that.proyx[4].Plate_Stock_Num;
                    parm.ECNMaster.Procurement_Deal_With_2 = that.proyx[4].Plate_Deal_With;
                    parm.ECNMaster.Procurement_Deal_With_2_0 = that.proyx[4].Procurement_Deal_With;
                    parm.ECNMaster.Procurement_Price_2 = that.proyx[4].Plate_Price;
                    parm.ECNMaster.Procurement_Mold_Cost_2 = that.proyx[4].Plate_Mold_Cost;
                    parm.ECNMaster.Procurement_Amount_2 = that.proyx[4].Plate_Amount;
                    parm.ECNMaster.Procurement_Bear_2 = that.proyx[4].Plate_Bear;
                    parm.ECNMaster.Procurement_Part_Code_3 = that.proyx[5].Plate_Part_Code;
                    parm.ECNMaster.Procurement_Part_Version_3 = that.proyx[5].Plate_Part_Version;
                    parm.ECNMaster.Procurement_Onway_Num_3 = that.proyx[5].Plate_Onway_Num;
                    parm.ECNMaster.Procurement_Stock_Num_3 = that.proyx[5].Plate_Stock_Num;
                    parm.ECNMaster.Procurement_Deal_With_3 = that.proyx[5].Plate_Deal_With;
                    parm.ECNMaster.Procurement_Deal_With_3_0 = that.proyx[5].Procurement_Deal_With;
                    parm.ECNMaster.Procurement_Price_3 = that.proyx[5].Plate_Price;
                    parm.ECNMaster.Procurement_Mold_Cost_3 = that.proyx[5].Plate_Mold_Cost;
                    parm.ECNMaster.Procurement_Amount_3 = that.proyx[5].Plate_Amount;
                    parm.ECNMaster.Procurement_Bear_3 = that.proyx[5].Plate_Bear;
                    parm.ECNMaster.Part_Code = that.proyx[6].Plate_Part_Code;
                    parm.ECNMaster.Part_Version = that.proyx[6].Plate_Part_Version;
                    parm.ECNMaster.Making_Onway_Num = that.proyx[6].Plate_Onway_Num;
                    parm.ECNMaster.Making_Stock_Num = that.proyx[6].Plate_Stock_Num;
                    parm.ECNMaster.Making_Deal_With = that.proyx[6].Plate_Deal_With;
                    parm.ECNMaster.Making_Deal_With_0 = that.proyx[6].Procurement_Deal_With;
                    parm.ECNMaster.Making_Price = that.proyx[6].Plate_Price;
                    parm.ECNMaster.Making_Mold_Cost = that.proyx[6].Plate_Mold_Cost;
                    parm.ECNMaster.Making_Amount = that.proyx[6].Plate_Amount;
                    parm.ECNMaster.Making_Bear = that.proyx[6].Plate_Bear;
                    parm.ECNMaster.Part_Code = that.proyx[7].Plate_Part_Code;
                    parm.ECNMaster.Part_Version = that.proyx[7].Plate_Part_Version;
                    parm.ECNMaster.Product_Onway_Num = that.proyx[7].Plate_Onway_Num;
                    parm.ECNMaster.Product_Stock_Num = that.proyx[7].Plate_Stock_Num;
                    parm.ECNMaster.Product_Deal_With = that.proyx[7].Plate_Deal_With;
                    parm.ECNMaster.Product_Deal_With_0 = that.proyx[7].Procurement_Deal_With;
                    parm.ECNMaster.Product_Price = that.proyx[7].Plate_Price;
                    parm.ECNMaster.Product_Mold_Cost = that.proyx[7].Plate_Mold_Cost;
                    parm.ECNMaster.Product_Amount = that.proyx[7].Plate_Amount;
                    parm.ECNMaster.Product_Bear = that.proyx[7].Plate_Bear;
                    console.log(JSON.stringify(parm));
                    that.loading = true;
                    that.ECNSignature.forEach(itme => {
                        itme.User_Name_BackUp = itme.User_Name_BackUp == null ? '' : itme.User_Name_BackUp;
                        itme.Opinion_Time = itme.Opinion_Time != '' ? itme.Opinion_Time : null;
                    });
                    that.ECNDetail.forEach(itme => {
                        itme.Plan_Time = itme.Plan_Time != '' ? itme.Plan_Time : null;
                        itme.Complete_Time = itme.Complete_Time != '' ? itme.Complete_Time : null;
                    });
                    that.$http.urlpost('Eng/ECN/SaveECN', parm, function (res) {
                        console.log(res);
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[284]'));
                            that.intidata();
                            that.getdlist(res.UniqueNum, '', '');
                            that.editvisi = false;
                        } else {
                            that.getdlist(that.ECNMaster.ECN_No, '', '');
                        }
                        that.loading = false;
                    });
                    loadingInstance.close()
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                } catch (error){
                    console.error('操作失败:', error);
                } finally {
                    that.savasLoading = false;
                }
            },

            //行编辑
            edits(e) {
                let that = this;
                if(that.code == e.ECN_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    that.editf = false;
                    that.code = e.ECN_No;
                    that.getdlist(that.code, '', '');
                }, 100);
            },
            // 编辑
            edit(jsd) {
                console.log(jsd);
                let that = this;
                that.editvisi = true;
                that.editf = false;
                that.IsEdit = 0;
                let code = jsd.row.ECN_No;
                that.getdlist(code, '', '');
            },

            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = val;
            },
            handleSelectionChange_Ecnper(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
            },
            imp() {
                let item = {
                    //label: '工艺导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/3',
                    url: '/exp/3',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/3'});
                this.$store.commit('selectMenu', item);
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ECNMaster.ECN_No
                };
                console.log(parm);
                that.$http.urlpost('/Eng/ECN/DelECNByID', parm, function (res) {
                    that.intidata();
                    that.confirmAdd();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.ECN_No + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该ECN数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            //截取日期
            timd(datasr) {
                let str = "";
                if (datasr) {
                    str = datasr.slice(0, 10);
                    console.log(str);
                }

                return str;

            },
            //获取当前时间
            getnewdate() {
                var date = new Date();
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                m = m < 10 ? '0' + m : m;
                var d = date.getDate();
                d = d < 10 ? '0' + d : d;
                var h = date.getHours();
                var mm = date.getMinutes();
                var ss = date.getSeconds();
                h = h < 10 ? '0' + h : h;
                mm = mm < 10 ? '0' + mm : mm;
                ss = ss < 10 ? '0' + ss : ss;
                return y + '/' + m + '/' + d + ' ' + h + ':' + mm + ':' + ss;
            },
            // 新增
            add() {
                let that = this
                that.openEdit()
                that.confirmAdd()
            },
            confirmAdd(){
                let that = this;
                that.IsEdit = 1;
                that.Type = 0;
                let datetime = Common.methods.getDatetime();
                that.getecnitem();
                if(that.userData.Login_DB.toLowerCase() !="my"){ 
                    that.getecnper();
                }
                that.ecnno = that.ecnnolist[0].items;
                that.ecnno1 = '';
                that.ecnno2 = '';
                that.ECNMaster = {
                    ECN_No: '',
                    Part_Code: '',
                    Part_Version: '',
                    ECN_Status: '0',
                    ECN_Source: '',
                    Client_Name: '',
                    Product_Name: '',
                    Client_ECN_No: '',
                    ECN_Type_Code: '',
                    Product_Stage_Code: '',
                    ECN_Urgency: '',
                    ECN_Description: '',
                    ECN_Accept_Time: null,
                    ECN_Accept_Person: '',
                    Client_Confirm: '',
                    Annex_Drawing_Num: '',
                    Annex_WI_Num: '',
                    Annex_Other_Num: '',
                    Plate_Part_Code_1: '',
                    Plate_Part_Version_1: '',
                    Plate_Onway_Num_1: '',
                    Plate_Stock_Num_1: '',
                    Plate_Deal_With_1: '',
                    Plate_Price_1: '',
                    Plate_Mold_Cost_1: '',
                    Plate_Amount_1: '',
                    Plate_Bear_1: '',
                    Plate_Part_Code_2: '',
                    Plate_Part_Version_2: '',
                    Plate_Onway_Num_2: '',
                    Plate_Stock_Num_2: '',
                    Plate_Deal_With_2: '',
                    Plate_Price_2: '',
                    Plate_Mold_Cost_2: '',
                    Plate_Amount_2: '',
                    Plate_Bear_2: '',
                    Plate_Part_Code_3: '',
                    Plate_Part_Version_3: '',
                    Plate_Onway_Num_3: '',
                    Plate_Stock_Num_3: '',
                    Plate_Deal_With_3: '',
                    Plate_Price_3: '',
                    Plate_Mold_Cost_3: '',
                    Plate_Amount_3: '',
                    Plate_Bear_3: '',
                    Procurement_Part_Code_1: '',
                    Procurement_Part_Version_1: '',
                    Procurement_Onway_Num_1: '',
                    Procurement_Stock_Num_1: '',
                    Procurement_Deal_With_1: '',
                    Procurement_Price_1: '',
                    Procurement_Mold_Cost_1: '',
                    Procurement_Amount_1: '',
                    Procurement_Bear_1: '',
                    Procurement_Part_Code_2: '',
                    Procurement_Part_Version_2: '',
                    Procurement_Onway_Num_2: '',
                    Procurement_Stock_Num_2: '',
                    Procurement_Deal_With_2: '',
                    Procurement_Price_2: '',
                    Procurement_Mold_Cost_2: '',
                    Procurement_Amount_2: '',
                    Procurement_Bear_2: '',
                    Procurement_Part_Code_3: '',
                    Procurement_Part_Version_3: '',
                    Procurement_Onway_Num_3: '',
                    Procurement_Stock_Num_3: '',
                    Procurement_Deal_With_3: '',
                    Procurement_Price_3: '',
                    Procurement_Mold_Cost_3: '',
                    Procurement_Amount_3: '',
                    Procurement_Bear_3: '',
                    Making_Onway_Num: '',
                    Making_Stock_Num: '',
                    Making_Deal_With: '',
                    Making_Price: '',
                    Making_Mold_Cost: '',
                    Making_Amount: '',
                    Making_Bear: '',
                    Product_Onway_Num: '',
                    Product_Stock_Num: '',
                    Product_Deal_With: '',
                    Product_Price: '',
                    Product_Mold_Cost: '',
                    Product_Amount: '',
                    Product_Bear: '',
                    Planner: '',
                    Planner_remark: '',
                    Planner_Affirm: '',
                    Original_Price: '',
                    Current_Price: '',
                    Client_Accept: '',
                    Client_Accept_Time: null,
                    Create_Person: this.user + '(' + that.userData.EmpCode + ')',
                    Create_Time: null,
                    Audit_Person: '',
                    Audit_Time: null,
                    Confirm_Person: '',
                    Confirm_Time: null,
                    ECN_Produce_Person: '',
                    ECN_Produce_Time: '',
                    ECN_Purchase_Person: '',
                    ECN_Purchase_Time: null,
                    ECN_Notes: '',
                    Department: '',
                    ECN_Close_Time: null,
                    ECN_Close_Person: this.user + '(' + that.userData.EmpCode + ')',
                    Modify_Person: '',
                    Modify_Time: new Date(),
                    Plate_Deal_With_1_0: '',
                    Plate_Deal_With_2_0: '',
                    Plate_Deal_With_3_0: '',
                    Procurement_Deal_With_1_0: '',
                    Procurement_Deal_With_2_0: '',
                    Procurement_Deal_With_3_0: '',
                    Making_Deal_With_0: '',
                    Product_Deal_With_0: '',
                    RoutingStr: '',
                    New_flag: '',
                    itemvernum: '',
                    RejectStr1: '',
                    RejectStr2: ''
                };
                that.PartLists=[],
                this.editvisi = true;
                this.editf = true;
                that.code = ''
                that.$http.urlpost('/Eng/ECN/GetSupercodeInfo', '', function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent.length == 2){
                            if(res.DataContent[0] != null){
                                that.ECNMaster.Audit_Person = res.DataContent[0].name + '(' + res.DataContent[0].code + ')'
                            }
                            if(res.DataContent[1] != null){
                                that.ECNMaster.Confirm_Person = res.DataContent[1].name + '(' + res.DataContent[1].code + ')'
                            }
                        }
                    }
                });
                this.authority(2);
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'ECNViewInfo');
            },
            // 刷新
            reflash() {
                let that = this;
                that.intidata(); //刷新左边
                //刷右边
                if (!that.$limits.fnIsEmpty(that.ECNMaster.ECN_No)) {
                    that.getdlist(that.ECNMaster.ECN_No, '', '');
                } else {
                    //清空右边
                    that.confirmAdd();
                }
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                    })
                    .catch(() => {
                    });
            },
            //导出·
            exp() {
                /*let that = this;
                that.showloading = that.openLoading();
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //				if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //				}
                });
                console.log(JSON.stringify(parm));
                that.$http.urlpost('/Eng/ECN/ECNExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.showloading.close();
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ECNViewInfo",
                    fromname: that.$t('getapi[6125]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },

            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.datajson.findIndex(item => item.ECN_No === val.ECN_No);
                    this.indf = result;
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            // 刷新统计信息
            refreshView() {
                let that = this
                that.$http.urlpost('/Eng/ECN/DelayPerson', '', function (res) {
                    if (res.Success == 1) {
                        that.intidata()
                    }
                });
            },
            // 选择审核人和批准人
            selectEmployee(val){
                let that = this
                that.employeeType = val
                that.$refs.employee.clearInput(true);
            },
            getEmployee(data){
                let that = this
                console.log(data)
                if(that.employeeType == 1){
                    that.ECNMaster.Audit_Person =  data.name + '(' + data.code + ')'
                } else {
                    that.ECNMaster.Confirm_Person = data.name + '(' + data.code + ')'
                }
            },
            addpart(val){                
                let that = this;
                that.partVisible = true;
                that.$refs.setpartlist.clearInput(that.partVisible, null);
            },            
            getPartlist(data){
                let that = this;
                let arr = data.filter(item => {
                    return that.PartLists.every(item2 => {
                        return item.part_code != item2.part_code;
                    });
                });
                data=arr;
                for (let i = 0; i < data.length; i++) {
                        that.PartLists = [
                            ...that.PartLists,
                            {
                                exclusively_id:0,
                                part_code:data[i].part_code,
                                part_version:data[i].part_version,
                                page_no:data[i].page_no,
                            }
                        ];
                    }
            },
            delpart() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            LangType: that.$processdata.getLang(),
                            Lists: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.PartLists.splice(that.selectData[i].index, 1);
                            if (that.selectData[i].exclusively_id!=0) {
                                let datatmp = {
                                    relation_ecn_no: that.selectData[i].relation_ecn_no,
                                    exclusively_id: that.selectData[i].exclusively_id,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        
                        if (parm.Lists.length > 0) {
                            that.btn.delpart = false
                            that.$http.urlpost('/Eng/ECN/DelEcnPart', parm, function (res) {
                                that.btn.delpart = true
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            addSign(val){
                let that = this;
                that.signVisible = true;
                that.$refs.setsignlist.clearInput(that.signVisible, null);
            },
            delline() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            LangType: that.$processdata.getLang(),
                            Lists: []
                        };
                        console.log(that.selectData);
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.ecnper.splice(that.selectData[i].index, 1);
                            if (that.selectData[i].isadd==0) {
                                let datatmp = {
                                    Relation_ECN_No: that.selectData[i].Relation_ECN_No,
                                    Relation_Signature_Strategy_No: that.selectData[i].Relation_Signature_Strategy_No,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        
                        if (parm.Lists.length > 0) {
                            that.btn.delsign = false
                            that.$http.urlpost('/Eng/ECN/DelSignature', parm, function (res) {
                                that.btn.delsign = true
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getdlist(that.ECNMaster.ECN_No, '', '');
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            getSignlist(data){
                let that = this;
                let arr = data.filter(item => {
                    return that.ecnper.every(item2 => {
                        return item.Signature_Strategy_No != item2.Relation_Signature_Strategy_No ;
                    });
                });
                data=arr;
                for (let i = 0; i < data.length; i++) {
                        that.ecnper = [
                            ...that.ecnper,
                            {
                                Opinion : null,
                                superior_flag : 0,
                                Opinion_Person : data[i].User_Name,
                                Opinion_Time : null,
                                Relation_ECN_No : null,
                                Relation_Signature_Strategy_No : data[i].Signature_Strategy_No,
                                opinion_status : '-1',
                                role_name :data[i].Role_Name,
                                user_name : data[i].User_Name,
                                iasdd:1,  
                            }
                        ];
                    }
            }
        }
    };
</script>
<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 5px;
            }
        }
    }

    .boxs {
        width: 100%;
        min-width: 840px;
    }

    .boxs > div {
        width: 30%;
        display: inline-block;
        white-space: nowrap;
        line-height: 30px;
    }

    .boxs > div > label.el-checkbox {
        min-width: 100px;
    }

    .box .bbl span {
        min-width: 0 !important;
    }

    .quill-editor.myQuillEditor {
        /*height: 400px;*/
        overflow-y: auto;
    }

    .bred > input {
        background: red;
        color: #fff;
    }
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }
</style>
